import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO 8601-encoded date */
  ISO8601Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
  Upload: any;
};

export enum AdherableStructureTypeEnum {
  Department = 'Department',
  Institution = 'Institution',
  Spinoff = 'Spinoff'
}

/** Adherables that can be references to an Institution */
export type AdherableUnion = Department | Institution | Spinoff;

export type AdherenceInformation = {
  __typename?: 'AdherenceInformation';
  adherable: AdherableUnion;
  id: Scalars['ID'];
  institution: InstitutionInterface;
  person?: Maybe<Person>;
  personRole?: Maybe<PersonRoleEnum>;
};

export enum AdherenceTypeEnum {
  OtherAdherenceType = 'otherAdherenceType'
}

export type AdherentStructure = {
  __typename?: 'AdherentStructure';
  adherable: AdherableUnion;
  adherableId: Scalars['ID'];
  adherableType: AdherableStructureTypeEnum;
  adherenceType?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  institution: InstitutionInterface;
  person: Person;
  personRole?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type AdherentStructureInput = {
  adherableId: Scalars['ID'];
  adherableType: AdherableStructureTypeEnum;
  adherenceType?: InputMaybe<AdherenceTypeEnum>;
  institutionId: Scalars['ID'];
  personId?: InputMaybe<Scalars['ID']>;
  personRole?: InputMaybe<PersonRoleEnum>;
};

export type AdministrativeBody = LegalBody & {
  __typename?: 'AdministrativeBody';
  administrativeBodyType: AdministrativeBodyTypeEnum;
  bodyType: LegalBodyTypeEnum;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  expectedEmployeeNumber?: Maybe<Scalars['Int']>;
  expiryDate?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  institutionId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Role>>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type AdministrativeBodyInput = {
  administrativeBodyType?: InputMaybe<AdministrativeBodyTypeEnum>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  expectedEmployeeNumber?: InputMaybe<Scalars['Int']>;
  expiryDate?: InputMaybe<Scalars['ISO8601Date']>;
  institutionId?: InputMaybe<Scalars['ID']>;
  note?: InputMaybe<Scalars['String']>;
};

export enum AdministrativeBodyTypeEnum {
  AdministrativeBoard = 'administrativeBoard',
  BoardOfDirectors = 'boardOfDirectors',
  ConsortiumCouncil = 'consortiumCouncil',
  Director = 'director',
  ManagementBoard = 'managementBoard',
  OtherAdministrativeBody = 'otherAdministrativeBody',
  ScientificTechnicalCommittee = 'scientificTechnicalCommittee',
  SoleDirector = 'soleDirector'
}

export type AdvisoryBody = LegalBody & {
  __typename?: 'AdvisoryBody';
  advisoryBodyType: AdvisoryBodyTypeEnum;
  bodyType: LegalBodyTypeEnum;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  expectedEmployeeNumber?: Maybe<Scalars['Int']>;
  expiryDate?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  institutionId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Role>>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type AdvisoryBodyInput = {
  advisoryBodyType?: InputMaybe<AdvisoryBodyTypeEnum>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  expectedEmployeeNumber?: InputMaybe<Scalars['Int']>;
  expiryDate?: InputMaybe<Scalars['ISO8601Date']>;
  institutionId?: InputMaybe<Scalars['ID']>;
  note?: InputMaybe<Scalars['String']>;
};

export enum AdvisoryBodyTypeEnum {
  ConsortiumConsult = 'consortiumConsult',
  OtherAdvisoryBody = 'otherAdvisoryBody',
  ScientificCommittee = 'scientificCommittee',
  ScientificConsult = 'scientificConsult',
  ScientificTechnicalCommittee = 'scientificTechnicalCommittee'
}

export type AnnualAccountingReport = Approvable & {
  __typename?: 'AnnualAccountingReport';
  approvalDocument?: Maybe<Pdf>;
  approved?: Maybe<Scalars['Boolean']>;
  consolidatedFinancialReport?: Maybe<Scalars['Boolean']>;
  consolidatedUniversityFinancialReport?: Maybe<Scalars['Boolean']>;
  controlBodyReportDocument?: Maybe<Pdf>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  dateOfApproval?: Maybe<Scalars['ISO8601Date']>;
  employeeNumber?: Maybe<Scalars['Int']>;
  exerciseResult?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  institution: InstitutionInterface;
  netAssets?: Maybe<Scalars['Float']>;
  note?: Maybe<Scalars['String']>;
  productionValue?: Maybe<Scalars['Float']>;
  revenue?: Maybe<Scalars['Float']>;
  socialCapital?: Maybe<Scalars['String']>;
  supplementaryNoteDocument?: Maybe<Pdf>;
  universityFinancialReport?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  year: Scalars['Int'];
};

export type AnnualAccountingReportInput = {
  approvalDocument?: InputMaybe<Scalars['Upload']>;
  consolidatedFinancialReport?: InputMaybe<Scalars['Boolean']>;
  consolidatedUniversityFinancialReport?: InputMaybe<Scalars['Boolean']>;
  controlBodyReportDocument?: InputMaybe<Scalars['Upload']>;
  dateOfApproval?: InputMaybe<Scalars['ISO8601Date']>;
  employeeNumber?: InputMaybe<Scalars['Int']>;
  exerciseResult?: InputMaybe<Scalars['Float']>;
  institutionId: Scalars['ID'];
  netAssets?: InputMaybe<Scalars['Float']>;
  note?: InputMaybe<Scalars['String']>;
  productionValue?: InputMaybe<Scalars['Float']>;
  revenue?: InputMaybe<Scalars['Float']>;
  socialCapital?: InputMaybe<Scalars['String']>;
  supplementaryNoteDocument?: InputMaybe<Scalars['Upload']>;
  universityFinancialReport?: InputMaybe<Scalars['Boolean']>;
  year: Scalars['Int'];
};

export type Approvable = {
  approved?: Maybe<Scalars['Boolean']>;
};

export type ApprovableInput = {
  approvableId: Scalars['ID'];
  approvableType: ApprovableTypeEnum;
  approved: Scalars['Boolean'];
};

export enum ApprovableTypeEnum {
  AnnualAccountingReport = 'AnnualAccountingReport',
  Partnership = 'Partnership',
  Role = 'Role',
  VersionedRecord = 'VersionedRecord'
}

/** Objects that can be approved and disapproved */
export type ApprovableUnion = AnnualAccountingReport | Partnership | Role | VersionedFloat | VersionedInteger | VersionedString;

export type AtecoActivity = {
  __typename?: 'AtecoActivity';
  atecoSector: AtecoSector;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  institution: InstitutionInterface;
  percentage: Scalars['Float'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type AtecoActivityInput = {
  atecoSectorId: Scalars['ID'];
  institutionId: Scalars['ID'];
  percentage?: InputMaybe<Scalars['Float']>;
};

export type AtecoSector = {
  __typename?: 'AtecoSector';
  atecoCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  institutions?: Maybe<Array<Institution>>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};


export type AtecoSectorInstitutionsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for AtecoSector. */
export type AtecoSectorConnection = {
  __typename?: 'AtecoSectorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AtecoSectorEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AtecoSector>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int'];
};

/** An edge in a connection. */
export type AtecoSectorEdge = {
  __typename?: 'AtecoSectorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<AtecoSector>;
};

export type AtecoSectorInput = {
  atecoCode?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Attachment = {
  __typename?: 'Attachment';
  attachedDocument: Pdf;
  attachmentType: AttachmentTypeEnum;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  expiryDate?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  institution: InstitutionInterface;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  validFrom?: Maybe<Scalars['ISO8601Date']>;
};

export type AttachmentInput = {
  attachedDocument?: InputMaybe<Scalars['Upload']>;
  attachmentType?: InputMaybe<AttachmentTypeEnum>;
  description?: InputMaybe<Scalars['String']>;
  expiryDate?: InputMaybe<Scalars['ISO8601Date']>;
  institutionId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  validFrom?: InputMaybe<Scalars['ISO8601Date']>;
};

export enum AttachmentTypeEnum {
  AccesionAct = 'accesionAct',
  CompanyRegistrationReport = 'companyRegistrationReport',
  ConstitutiveAct = 'constitutiveAct',
  CurrentStatute = 'currentStatute',
  OtherType = 'otherType',
  RecognitionDocument = 'recognitionDocument'
}

export type AuthHeaderData = {
  __typename?: 'AuthHeaderData';
  accessToken?: Maybe<Scalars['String']>;
  client?: Maybe<Scalars['String']>;
  expiry?: Maybe<Scalars['String']>;
  tokenType?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
};

export type AuthProviderEmailSignInInput = {
  /** Email */
  email: Scalars['String'];
  password: Scalars['String'];
};

export type AuthProviderEmailSignUpInput = {
  /** Example format: YYYY-MM-DD */
  birthday: Scalars['ISO8601DateTime'];
  /** Email */
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};

export type Compensation = {
  __typename?: 'Compensation';
  compensation: Scalars['Float'];
  compensationNature: Scalars['String'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  role: Role;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  year: Scalars['Int'];
};

export type CompensationInput = {
  compensation?: InputMaybe<Scalars['Float']>;
  compensationNature?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  roleId: Scalars['ID'];
  year?: InputMaybe<Scalars['Int']>;
};

export type ControlBody = LegalBody & {
  __typename?: 'ControlBody';
  bodyType: LegalBodyTypeEnum;
  controlBodyType: ControlBodyTypeEnum;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  expectedEmployeeNumber?: Maybe<Scalars['Int']>;
  expiryDate?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  institutionId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Role>>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type ControlBodyInput = {
  controlBodyType?: InputMaybe<ControlBodyTypeEnum>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  expectedEmployeeNumber?: InputMaybe<Scalars['Int']>;
  expiryDate?: InputMaybe<Scalars['ISO8601Date']>;
  institutionId?: InputMaybe<Scalars['ID']>;
  note?: InputMaybe<Scalars['String']>;
};

export enum ControlBodyTypeEnum {
  BoardOfAuditors = 'boardOfAuditors',
  OtherControlBody = 'otherControlBody',
  SupervisoryBoard = 'supervisoryBoard'
}

export type Deliberation = {
  __typename?: 'Deliberation';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  date: Scalars['ISO8601DateTime'];
  deliberationDocument: Pdf;
  deliberationType: DeliberationTypeEnum;
  description?: Maybe<DeliberationDescriptionEnum>;
  id: Scalars['ID'];
  institution: Institution;
  note?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum DeliberationDescriptionEnum {
  Activation = 'activation',
  Adhesion = 'adhesion',
  BodyNomination = 'bodyNomination',
  Constitution = 'constitution',
  Dissolution = 'dissolution',
  Liquidation = 'liquidation',
  OtherObject = 'otherObject',
  Renewal = 'renewal',
  SharesPurchase = 'sharesPurchase',
  SharesSelling = 'sharesSelling',
  StatuteChange = 'statuteChange',
  Termination = 'termination',
  Withdrawal = 'withdrawal'
}

export type DeliberationInput = {
  date?: InputMaybe<Scalars['ISO8601DateTime']>;
  deliberationDocument?: InputMaybe<Scalars['Upload']>;
  deliberationType?: InputMaybe<DeliberationTypeEnum>;
  description?: InputMaybe<DeliberationDescriptionEnum>;
  institutionId?: InputMaybe<Scalars['ID']>;
  note?: InputMaybe<Scalars['String']>;
};

export enum DeliberationTypeEnum {
  Decree = 'decree',
  Deliberation = 'deliberation',
  Opinion = 'opinion',
  OtherType = 'otherType'
}

export type Department = {
  __typename?: 'Department';
  adherentInstitutionsInfo?: Maybe<Array<AdherenceInformation>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  fake: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};


export type DepartmentAdherentInstitutionsInfoArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for Department. */
export type DepartmentConnection = {
  __typename?: 'DepartmentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DepartmentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Department>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int'];
};

/** An edge in a connection. */
export type DepartmentEdge = {
  __typename?: 'DepartmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Department>;
};

export type DepartmentValue = {
  __typename?: 'DepartmentValue';
  departmentNames: Array<Scalars['String']>;
  values: Array<Scalars['Int']>;
};

export type Institution = InstitutionInterface & {
  __typename?: 'Institution';
  active: Scalars['Boolean'];
  adherentStructuresInfo?: Maybe<Array<AdherenceInformation>>;
  adhesionDate?: Maybe<Scalars['ISO8601Date']>;
  allApproved: Scalars['Boolean'];
  annualAccountingReports?: Maybe<Array<AnnualAccountingReport>>;
  atecoActivities?: Maybe<Array<AtecoActivity>>;
  attachments?: Maybe<Array<Attachment>>;
  constitutionDate?: Maybe<Scalars['ISO8601Date']>;
  contacts?: Maybe<Scalars['String']>;
  corporatePurpose?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  deliberations?: Maybe<Array<Deliberation>>;
  duration?: Maybe<Scalars['ISO8601Date']>;
  expiringReminds?: Maybe<Array<Remind>>;
  expiryDate?: Maybe<Scalars['ISO8601Date']>;
  fiscalCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  idUGov?: Maybe<Scalars['String']>;
  institutionType?: Maybe<InstitutionTypeEnum>;
  isUniParticipate: Scalars['Boolean'];
  isVisible: Scalars['Boolean'];
  legalBodies?: Maybe<Array<LegalBody>>;
  mef?: Maybe<Scalars['Boolean']>;
  nominalValue?: Maybe<Scalars['Float']>;
  note?: Maybe<Scalars['String']>;
  partnerships?: Maybe<Array<Partnership>>;
  payments?: Maybe<Array<Payment>>;
  quote?: Maybe<Scalars['Float']>;
  quotes?: Maybe<Array<Quote>>;
  recognitionDate?: Maybe<Scalars['ISO8601Date']>;
  reminds?: Maybe<Array<Remind>>;
  roles?: Maybe<Array<Role>>;
  sector?: Maybe<Sector>;
  status?: Maybe<InstitutionStatusEnum>;
  unapproved: Array<ApprovableUnion>;
  uniParticipation?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  vAcronym?: Maybe<VersionedString>;
  vAcronyms?: Maybe<Array<VersionedString>>;
  vAdministrativeHeadquarter?: Maybe<VersionedString>;
  vAdministrativeHeadquarters?: Maybe<Array<VersionedString>>;
  vAnnualAccountingReports?: Maybe<Array<AnnualAccountingReport>>;
  vEmail?: Maybe<VersionedString>;
  vEmails?: Maybe<Array<VersionedString>>;
  vLegalResidence?: Maybe<VersionedString>;
  vLegalResidences?: Maybe<Array<VersionedString>>;
  vName?: Maybe<VersionedString>;
  vNames?: Maybe<Array<VersionedString>>;
  vOperationalHeadquarter?: Maybe<VersionedString>;
  vOperationalHeadquarters?: Maybe<Array<VersionedString>>;
  vPartnerships?: Maybe<Array<Partnership>>;
  vPhoneNumber?: Maybe<VersionedString>;
  vPhoneNumbers?: Maybe<Array<VersionedString>>;
  vRoles?: Maybe<Array<Role>>;
  vUniParticipation?: Maybe<VersionedUniParticipation>;
  vUniParticipations?: Maybe<Array<VersionedUniParticipation>>;
  vWebsite?: Maybe<VersionedString>;
  vWebsites?: Maybe<Array<VersionedString>>;
  vatNumber?: Maybe<Scalars['String']>;
  /**
   * partial_intersections = the new record partially intersects with the old record;
   *     								outer_intersections = the new record is bigger than the old record and entirely encloses it;
   *     								inner_intersections = the new record is smaller than the old record and entirely fits in it.
   */
  versionedRecordIntersections: VersionedRecordIntersections;
};


export type InstitutionExpiringRemindsArgs = {
  expiringWithinDays: Scalars['Int'];
};


export type InstitutionVersionedRecordIntersectionsArgs = {
  newRecord: VersionedRecordIntersectionInput;
};

export type InstitutionCreateInput = {
  constitutionDate: Scalars['ISO8601Date'];
  fiscalCode?: InputMaybe<Scalars['String']>;
  institutionType: InstitutionTypeEnum;
  uniParticipation: UniParticipationEnum;
  vLegalResidence: VersionedStringInput;
  vName: VersionedStringInput;
  vatNumber?: InputMaybe<Scalars['String']>;
};

export type InstitutionInterface = {
  active: Scalars['Boolean'];
  adherentStructuresInfo?: Maybe<Array<AdherenceInformation>>;
  adhesionDate?: Maybe<Scalars['ISO8601Date']>;
  allApproved: Scalars['Boolean'];
  annualAccountingReports?: Maybe<Array<AnnualAccountingReport>>;
  atecoActivities?: Maybe<Array<AtecoActivity>>;
  attachments?: Maybe<Array<Attachment>>;
  constitutionDate?: Maybe<Scalars['ISO8601Date']>;
  contacts?: Maybe<Scalars['String']>;
  corporatePurpose?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  deliberations?: Maybe<Array<Deliberation>>;
  duration?: Maybe<Scalars['ISO8601Date']>;
  expiringReminds?: Maybe<Array<Remind>>;
  expiryDate?: Maybe<Scalars['ISO8601Date']>;
  fiscalCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  idUGov?: Maybe<Scalars['String']>;
  institutionType?: Maybe<InstitutionTypeEnum>;
  isUniParticipate: Scalars['Boolean'];
  isVisible: Scalars['Boolean'];
  legalBodies?: Maybe<Array<LegalBody>>;
  mef?: Maybe<Scalars['Boolean']>;
  nominalValue?: Maybe<Scalars['Float']>;
  note?: Maybe<Scalars['String']>;
  partnerships?: Maybe<Array<Partnership>>;
  payments?: Maybe<Array<Payment>>;
  quote?: Maybe<Scalars['Float']>;
  quotes?: Maybe<Array<Quote>>;
  recognitionDate?: Maybe<Scalars['ISO8601Date']>;
  reminds?: Maybe<Array<Remind>>;
  roles?: Maybe<Array<Role>>;
  sector?: Maybe<Sector>;
  status?: Maybe<InstitutionStatusEnum>;
  unapproved: Array<ApprovableUnion>;
  uniParticipation?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  vAcronym?: Maybe<VersionedString>;
  vAcronyms?: Maybe<Array<VersionedString>>;
  vAdministrativeHeadquarter?: Maybe<VersionedString>;
  vAdministrativeHeadquarters?: Maybe<Array<VersionedString>>;
  vAnnualAccountingReports?: Maybe<Array<AnnualAccountingReport>>;
  vEmail?: Maybe<VersionedString>;
  vEmails?: Maybe<Array<VersionedString>>;
  vLegalResidence?: Maybe<VersionedString>;
  vLegalResidences?: Maybe<Array<VersionedString>>;
  vName?: Maybe<VersionedString>;
  vNames?: Maybe<Array<VersionedString>>;
  vOperationalHeadquarter?: Maybe<VersionedString>;
  vOperationalHeadquarters?: Maybe<Array<VersionedString>>;
  vPartnerships?: Maybe<Array<Partnership>>;
  vPhoneNumber?: Maybe<VersionedString>;
  vPhoneNumbers?: Maybe<Array<VersionedString>>;
  vRoles?: Maybe<Array<Role>>;
  vUniParticipation?: Maybe<VersionedUniParticipation>;
  vUniParticipations?: Maybe<Array<VersionedUniParticipation>>;
  vWebsite?: Maybe<VersionedString>;
  vWebsites?: Maybe<Array<VersionedString>>;
  vatNumber?: Maybe<Scalars['String']>;
  /**
   * partial_intersections = the new record partially intersects with the old record;
   *     								outer_intersections = the new record is bigger than the old record and entirely encloses it;
   *     								inner_intersections = the new record is smaller than the old record and entirely fits in it.
   */
  versionedRecordIntersections: VersionedRecordIntersections;
};


export type InstitutionInterfaceExpiringRemindsArgs = {
  expiringWithinDays: Scalars['Int'];
};


export type InstitutionInterfaceVersionedRecordIntersectionsArgs = {
  newRecord: VersionedRecordIntersectionInput;
};

export type InstitutionSearchResult = {
  __typename?: 'InstitutionSearchResult';
  foundVersionedRecord?: Maybe<VersionedRecord>;
  institution?: Maybe<InstitutionInterface>;
};

/** The connection type for InstitutionSearchResult. */
export type InstitutionSearchResultConnection = {
  __typename?: 'InstitutionSearchResultConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InstitutionSearchResultEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<InstitutionSearchResult>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int'];
};

/** An edge in a connection. */
export type InstitutionSearchResultEdge = {
  __typename?: 'InstitutionSearchResultEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<InstitutionSearchResult>;
};

export enum InstitutionStatusEnum {
  Active = 'active',
  Inactive = 'inactive'
}

export enum InstitutionTypeEnum {
  Association = 'association',
  Company = 'company',
  Consortium = 'consortium',
  ConsortiumCompany = 'consortiumCompany',
  Establishment = 'establishment',
  HoldingFoundation = 'holdingFoundation',
  InterdepartmentalCenter = 'interdepartmentalCenter',
  InteruniversityCenter = 'interuniversityCenter',
  OtherType = 'otherType',
  UniversityCenter = 'universityCenter',
  UniversityEstablishment = 'universityEstablishment'
}

export type InstitutionUpdateInput = {
  adhesionDate?: InputMaybe<Scalars['ISO8601Date']>;
  constitutionDate?: InputMaybe<Scalars['ISO8601Date']>;
  contacts?: InputMaybe<Scalars['String']>;
  corporatePurpose?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['ISO8601Date']>;
  expiryDate?: InputMaybe<Scalars['ISO8601Date']>;
  fiscalCode?: InputMaybe<Scalars['String']>;
  idUGov?: InputMaybe<Scalars['String']>;
  institutionType?: InputMaybe<InstitutionTypeEnum>;
  mef?: InputMaybe<Scalars['Boolean']>;
  nominalValue?: InputMaybe<Scalars['Float']>;
  note?: InputMaybe<Scalars['String']>;
  quote?: InputMaybe<Scalars['Float']>;
  recognitionDate?: InputMaybe<Scalars['ISO8601Date']>;
  sectorId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<InstitutionStatusEnum>;
  vAcronym?: InputMaybe<VersionedStringInput>;
  vAdministrativeHeadquarter?: InputMaybe<VersionedStringInput>;
  vEmail?: InputMaybe<VersionedStringInput>;
  vLegalResidence?: InputMaybe<VersionedStringInput>;
  vName?: InputMaybe<VersionedStringInput>;
  vOperationalHeadquarter?: InputMaybe<VersionedStringInput>;
  vPhoneNumber?: InputMaybe<VersionedStringInput>;
  vUniParticipation?: InputMaybe<VersionedUniParticipationEnumInput>;
  vWebsite?: InputMaybe<VersionedStringInput>;
  vatNumber?: InputMaybe<Scalars['String']>;
};

export type LegalBody = {
  bodyType: LegalBodyTypeEnum;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  expectedEmployeeNumber?: Maybe<Scalars['Int']>;
  expiryDate?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  institutionId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Role>>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum LegalBodyTypeEnum {
  AdministrativeBody = 'administrativeBody',
  AdvisoryBody = 'advisoryBody',
  ControlBody = 'controlBody',
  LegalRepresentative = 'legalRepresentative',
  OtherBody = 'otherBody',
  SteeringBody = 'steeringBody'
}

export type LegalRepresentative = LegalBody & {
  __typename?: 'LegalRepresentative';
  bodyType: LegalBodyTypeEnum;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  expectedEmployeeNumber?: Maybe<Scalars['Int']>;
  expiryDate?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  institutionId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Role>>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type LegalRepresentativeInput = {
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  expectedEmployeeNumber?: InputMaybe<Scalars['Int']>;
  expiryDate?: InputMaybe<Scalars['ISO8601Date']>;
  institutionId?: InputMaybe<Scalars['ID']>;
  note?: InputMaybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  adherentStructureCreate: AdherentStructure;
  adherentStructureDelete: OperationReturn;
  adherentStructureUpdate: AdherentStructure;
  /** Admin and dev only, argument is optional, if not present tries to confirm current user. Don't expect this to work in production. */
  adminUserConfirmEmail?: Maybe<User>;
  annualAccountingReportCreate: AnnualAccountingReport;
  annualAccountingReportDelete: OperationReturn;
  annualAccountingReportUpdate: AnnualAccountingReport;
  approvableApprove: ApprovableUnion;
  approvableApproveMany: Scalars['Boolean'];
  atecoActivityCreate: AtecoActivity;
  atecoActivityDelete: OperationReturn;
  atecoActivityUpdate: AtecoActivity;
  atecoSectorCreate: AtecoSector;
  atecoSectorDelete: OperationReturn;
  atecoSectorUpdate: AtecoSector;
  attachmentCreate: Attachment;
  attachmentDelete: OperationReturn;
  attachmentUpdate: Attachment;
  compensationCreate: Compensation;
  compensationDelete: OperationReturn;
  compensationUpdate: Compensation;
  deliberationCreate: Deliberation;
  deliberationDelete: OperationReturn;
  deliberationUpdate: Deliberation;
  institutionCreate?: Maybe<InstitutionInterface>;
  institutionDelete: OperationReturn;
  institutionSetStatus: InstitutionInterface;
  institutionUpdate: InstitutionInterface;
  legalBodyCreate: LegalBody;
  legalBodyDelete: OperationReturn;
  legalBodyUpdate: LegalBody;
  partnershipCreate: Partnership;
  partnershipDelete: OperationReturn;
  partnershipUpdate: Partnership;
  paymentCreate: Payment;
  paymentDelete: OperationReturn;
  paymentUpdate: Payment;
  personCreate?: Maybe<Person>;
  personDelete: OperationReturn;
  personUpdate: Person;
  quoteCreate: Quote;
  quoteDelete: OperationReturn;
  quoteUpdate: Quote;
  remindCreate: Remind;
  remindDelete: OperationReturn;
  remindUpdate: Remind;
  roleCreate: Role;
  roleDelete: OperationReturn;
  roleUpdate: Role;
  sectorCreate: Sector;
  sectorDelete: OperationReturn;
  sectorUpdate: Sector;
  userChangePassword?: Maybe<User>;
  userResendConfirmationEmail?: Maybe<OperationReturn>;
  userResetPassword?: Maybe<UserSignIn>;
  userResetPasswordRequest?: Maybe<OperationReturn>;
  userSignIn: UserSignIn;
  userSignOut?: Maybe<User>;
  userSignUp: UserSignIn;
  userUpdate?: Maybe<User>;
  versionedRecordDelete: OperationReturn;
  versionedRecordUpdate: VersionedRecord;
};


export type MutationAdherentStructureCreateArgs = {
  input: AdherentStructureInput;
};


export type MutationAdherentStructureDeleteArgs = {
  adherentStructureId: Scalars['ID'];
};


export type MutationAdherentStructureUpdateArgs = {
  adherentStructureId: Scalars['ID'];
  input: AdherentStructureInput;
};


export type MutationAdminUserConfirmEmailArgs = {
  input?: InputMaybe<UserConfirmEmailInput>;
};


export type MutationAnnualAccountingReportCreateArgs = {
  input: AnnualAccountingReportInput;
};


export type MutationAnnualAccountingReportDeleteArgs = {
  annualAccountingReportId: Scalars['ID'];
};


export type MutationAnnualAccountingReportUpdateArgs = {
  annualAccountingReportId: Scalars['ID'];
  input: AnnualAccountingReportInput;
};


export type MutationApprovableApproveArgs = {
  input: ApprovableInput;
};


export type MutationApprovableApproveManyArgs = {
  input: Array<ApprovableInput>;
};


export type MutationAtecoActivityCreateArgs = {
  input: AtecoActivityInput;
};


export type MutationAtecoActivityDeleteArgs = {
  atecoActivityId: Scalars['ID'];
};


export type MutationAtecoActivityUpdateArgs = {
  atecoActivityId: Scalars['ID'];
  input: AtecoActivityInput;
};


export type MutationAtecoSectorCreateArgs = {
  input: AtecoSectorInput;
};


export type MutationAtecoSectorDeleteArgs = {
  atecoSectorId: Scalars['ID'];
};


export type MutationAtecoSectorUpdateArgs = {
  atecoSectorId: Scalars['ID'];
  input: AtecoSectorInput;
};


export type MutationAttachmentCreateArgs = {
  input: AttachmentInput;
};


export type MutationAttachmentDeleteArgs = {
  attachmentId: Scalars['ID'];
};


export type MutationAttachmentUpdateArgs = {
  attachmentId: Scalars['ID'];
  input: AttachmentInput;
};


export type MutationCompensationCreateArgs = {
  input: CompensationInput;
};


export type MutationCompensationDeleteArgs = {
  compensationId: Scalars['ID'];
};


export type MutationCompensationUpdateArgs = {
  compensationId: Scalars['ID'];
  input: CompensationInput;
};


export type MutationDeliberationCreateArgs = {
  input: DeliberationInput;
};


export type MutationDeliberationDeleteArgs = {
  deliberationId: Scalars['ID'];
};


export type MutationDeliberationUpdateArgs = {
  deliberationId: Scalars['ID'];
  input: DeliberationInput;
};


export type MutationInstitutionCreateArgs = {
  institutionInput?: InputMaybe<InstitutionCreateInput>;
  spinoffInput?: InputMaybe<SpinoffCreateInput>;
};


export type MutationInstitutionDeleteArgs = {
  institutionId: Scalars['ID'];
};


export type MutationInstitutionSetStatusArgs = {
  institutionId: Scalars['ID'];
  status: InstitutionStatusEnum;
};


export type MutationInstitutionUpdateArgs = {
  institutionId: Scalars['ID'];
  institutionInput?: InputMaybe<InstitutionUpdateInput>;
  spinoffInput?: InputMaybe<SpinoffUpdateInput>;
};


export type MutationLegalBodyCreateArgs = {
  administrativeBodyInput?: InputMaybe<AdministrativeBodyInput>;
  advisoryBodyInput?: InputMaybe<AdvisoryBodyInput>;
  controlBodyInput?: InputMaybe<ControlBodyInput>;
  legalRepresentativeInput?: InputMaybe<LegalRepresentativeInput>;
  otherBodyInput?: InputMaybe<OtherBodyInput>;
  steeringBodyInput?: InputMaybe<SteeringBodyInput>;
};


export type MutationLegalBodyDeleteArgs = {
  legalBodyId: Scalars['ID'];
};


export type MutationLegalBodyUpdateArgs = {
  administrativeBodyInput?: InputMaybe<AdministrativeBodyInput>;
  advisoryBodyInput?: InputMaybe<AdvisoryBodyInput>;
  controlBodyInput?: InputMaybe<ControlBodyInput>;
  legalBodyId: Scalars['ID'];
  legalRepresentativeInput?: InputMaybe<LegalRepresentativeInput>;
  otherBodyInput?: InputMaybe<OtherBodyInput>;
  steeringBodyInput?: InputMaybe<SteeringBodyInput>;
};


export type MutationPartnershipCreateArgs = {
  input: PartnershipInput;
};


export type MutationPartnershipDeleteArgs = {
  partnershipId: Scalars['ID'];
};


export type MutationPartnershipUpdateArgs = {
  input: PartnershipInput;
  partnershipId: Scalars['ID'];
};


export type MutationPaymentCreateArgs = {
  input: PaymentInput;
};


export type MutationPaymentDeleteArgs = {
  paymentId: Scalars['ID'];
};


export type MutationPaymentUpdateArgs = {
  input: PaymentInput;
  paymentId: Scalars['ID'];
};


export type MutationPersonCreateArgs = {
  input: PersonInput;
};


export type MutationPersonDeleteArgs = {
  personId: Scalars['ID'];
};


export type MutationPersonUpdateArgs = {
  input: PersonInput;
  personId: Scalars['ID'];
};


export type MutationQuoteCreateArgs = {
  input: QuoteInput;
};


export type MutationQuoteDeleteArgs = {
  quoteId: Scalars['ID'];
};


export type MutationQuoteUpdateArgs = {
  input: QuoteInput;
  quoteId: Scalars['ID'];
};


export type MutationRemindCreateArgs = {
  input: RemindInput;
};


export type MutationRemindDeleteArgs = {
  remindId: Scalars['ID'];
};


export type MutationRemindUpdateArgs = {
  input: RemindInput;
  remindId: Scalars['ID'];
};


export type MutationRoleCreateArgs = {
  input: RoleInput;
};


export type MutationRoleDeleteArgs = {
  roleId: Scalars['ID'];
};


export type MutationRoleUpdateArgs = {
  input: RoleInput;
  roleId: Scalars['ID'];
};


export type MutationSectorCreateArgs = {
  input: SectorInput;
};


export type MutationSectorDeleteArgs = {
  sectorId: Scalars['ID'];
};


export type MutationSectorUpdateArgs = {
  input: SectorInput;
  sectorId: Scalars['ID'];
};


export type MutationUserChangePasswordArgs = {
  input: UserChangePasswordInput;
};


export type MutationUserResetPasswordArgs = {
  input: UserResetPasswordInput;
};


export type MutationUserResetPasswordRequestArgs = {
  input: UserResetPasswordRequestInput;
};


export type MutationUserSignInArgs = {
  input: SignInInput;
};


export type MutationUserSignUpArgs = {
  input: SignUpInput;
};


export type MutationUserUpdateArgs = {
  input: UserUpdateInput;
};


export type MutationVersionedRecordDeleteArgs = {
  versionedRecordId: Scalars['ID'];
};


export type MutationVersionedRecordUpdateArgs = {
  versionedFloatInput?: InputMaybe<VersionedFloatInput>;
  versionedIntegerInput?: InputMaybe<VersionedIntegerInput>;
  versionedRecordId: Scalars['ID'];
  versionedStringInput?: InputMaybe<VersionedStringInput>;
  versionedUniParticipationEnumInput?: InputMaybe<VersionedUniParticipationEnumInput>;
};

export type NameValue = {
  __typename?: 'NameValue';
  names: Array<Scalars['String']>;
  values: Array<Scalars['Int']>;
};

/** Generic return type for operations that have no intrinsic return type */
export type OperationReturn = {
  __typename?: 'OperationReturn';
  success?: Maybe<OperationReturnTypeEnum>;
};

export enum OperationReturnTypeEnum {
  Ko = 'ko',
  Ok = 'ok'
}

export type OtherBody = LegalBody & {
  __typename?: 'OtherBody';
  bodyType: LegalBodyTypeEnum;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  expectedEmployeeNumber?: Maybe<Scalars['Int']>;
  expiryDate?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  institutionId: Scalars['ID'];
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Role>>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type OtherBodyInput = {
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  expectedEmployeeNumber?: InputMaybe<Scalars['Int']>;
  expiryDate?: InputMaybe<Scalars['ISO8601Date']>;
  institutionId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type Partnership = Approvable & {
  __typename?: 'Partnership';
  approved?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  endDate?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  institution: InstitutionInterface;
  nominalValue?: Maybe<Scalars['Float']>;
  note?: Maybe<Scalars['String']>;
  partnerName: Scalars['String'];
  personKind?: Maybe<PartnershipPersonKind>;
  proposer: Scalars['Boolean'];
  quote?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['ISO8601Date']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type PartnershipInput = {
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  institutionId: Scalars['ID'];
  nominalValue?: InputMaybe<Scalars['Float']>;
  note?: InputMaybe<Scalars['String']>;
  partnerName: Scalars['String'];
  personKind?: InputMaybe<PartnershipPersonKind>;
  proposer?: InputMaybe<Scalars['Boolean']>;
  quote?: InputMaybe<Scalars['Float']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};

export enum PartnershipPersonKind {
  NaturalPerson = 'natural_person',
  PrivateLegalPerson = 'private_legal_person',
  PublicLegalPerson = 'public_legal_person'
}

export type Payment = {
  __typename?: 'Payment';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  paymentDate: Scalars['ISO8601Date'];
  paymentDocument: Pdf;
  quote: Quote;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum PaymentFrequencyEnum {
  Annual = 'annual',
  UnaTantum = 'unaTantum'
}

export type PaymentInput = {
  note?: InputMaybe<Scalars['String']>;
  paymentDate?: InputMaybe<Scalars['ISO8601Date']>;
  paymentDocument?: InputMaybe<Scalars['Upload']>;
  quoteId: Scalars['ID'];
};

export type Pdf = {
  __typename?: 'Pdf';
  url?: Maybe<Scalars['String']>;
};

export type Person = {
  __typename?: 'Person';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  fiscalCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  personalDocument?: Maybe<Pdf>;
  roles?: Maybe<Array<Role>>;
  uniEmployee: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for Person. */
export type PersonConnection = {
  __typename?: 'PersonConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PersonEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Person>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of objects returned from this Plural Query */
  totalCount: Scalars['Int'];
  /** Total # of pages, based on total count and pagesize */
  totalPageCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PersonEdge = {
  __typename?: 'PersonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Person>;
};

export type PersonInput = {
  fiscalCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  personalDocument?: InputMaybe<Scalars['Upload']>;
  uniEmployee?: InputMaybe<Scalars['Boolean']>;
};

export enum PersonRoleEnum {
  InternalReferent = 'internalReferent',
  OtherRole = 'otherRole'
}

export type Query = {
  __typename?: 'Query';
  adherentStructure?: Maybe<AdherentStructure>;
  /** Returns a list of adherent structures that can be referenced to an Institution */
  adherentStructureSearch?: Maybe<Array<AdherableUnion>>;
  /** Returns a list of only the Institutions (no Spinoff) that have data to be approved */
  adminInstitutionsWithUnapproved?: Maybe<Array<InstitutionInterface>>;
  /** Returns a list of all the available sectors. */
  allSectors?: Maybe<Array<Sector>>;
  /** Returns all users, Dev and Admin only */
  allUsers?: Maybe<Array<User>>;
  annualAccountingReport?: Maybe<AnnualAccountingReport>;
  atecoActivity?: Maybe<AtecoActivity>;
  atecoSector?: Maybe<AtecoSector>;
  /** Return a list of ateco sectors which name or ateco code matches a keyword */
  atecoSectorSearch?: Maybe<AtecoSectorConnection>;
  attachment?: Maybe<Attachment>;
  /** Returns the number of active institutions and spinoffs TODAY, grouped per department */
  chartActiveInstitutionsAndSpinoffsPerDepartment?: Maybe<DepartmentValue>;
  /** Returns the number of active spinoffs TODAY, grouped per department */
  chartActiveSpinoffsPerDepartment?: Maybe<DepartmentValue>;
  /** Returns two arrays containing the years and the counts per year */
  chartActiveSpinoffsPerYear?: Maybe<YearValue>;
  /** Returns the yearly sum of exercise results of scoped institutions */
  chartScopedExerciseResultsPerYear?: Maybe<YearValue>;
  /** Returns the number of scoped institutions, grouped per constitution year */
  chartScopedInstitutionsPerConstitutionYear?: Maybe<YearValue>;
  /** Returns the number of scoped institutions, grouped per department */
  chartScopedInstitutionsPerDepartment?: Maybe<NameValue>;
  /** Returns the number of scoped institutions, grouped per recognition year */
  chartScopedInstitutionsPerRecognitionYear?: Maybe<YearValue>;
  /** Returns the number of scoped institutions, grouped per sector */
  chartScopedInstitutionsPerSector?: Maybe<NameValue>;
  /** Returns the yearly sum of production values of scoped institutions */
  chartScopedProductionValuesPerYear?: Maybe<YearValue>;
  compensation?: Maybe<Compensation>;
  deliberation?: Maybe<Deliberation>;
  department?: Maybe<Department>;
  /** Returns a list of departments which name matches a keyword */
  departmentSearch?: Maybe<DepartmentConnection>;
  /** Returns a list of all the departments */
  departments?: Maybe<Array<Department>>;
  /** Returns the state of an Institution or a Spinoff at a given date, or at the date of today by default */
  institution?: Maybe<InstitutionInterface>;
  /** Returns a list of Institutions & Spinoffs that match the specified filters */
  institutionSearch?: Maybe<InstitutionSearchResultConnection>;
  /** Returns a list of the institutions that have reminds which expire in N days */
  institutionsWithExpiringReminds?: Maybe<Array<InstitutionInterface>>;
  /** Returns a subtype of LegalBody */
  legalBody?: Maybe<LegalBody>;
  /** Gets the current user, can also be used for token validations */
  me?: Maybe<User>;
  partnership?: Maybe<Partnership>;
  payment?: Maybe<Payment>;
  person?: Maybe<Person>;
  /** Returns a list of people that match a keyword */
  personSearch?: Maybe<PersonConnection>;
  quote?: Maybe<Quote>;
  remind?: Maybe<Remind>;
  /** Returns all the reminds that expire within the specified day limit. If no limit is specified, returns all reminds. */
  reminds?: Maybe<Array<Remind>>;
  role?: Maybe<Role>;
  sector?: Maybe<Sector>;
  /** Find a user by id */
  user?: Maybe<User>;
};


export type QueryAdherentStructureArgs = {
  id: Scalars['ID'];
};


export type QueryAdherentStructureSearchArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
};


export type QueryAnnualAccountingReportArgs = {
  id: Scalars['ID'];
};


export type QueryAtecoActivityArgs = {
  id: Scalars['ID'];
};


export type QueryAtecoSectorArgs = {
  id: Scalars['ID'];
};


export type QueryAtecoSectorSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keyword?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAttachmentArgs = {
  id: Scalars['ID'];
};


export type QueryChartActiveSpinoffsPerYearArgs = {
  fromYear: Scalars['Int'];
  toYear: Scalars['Int'];
};


export type QueryChartScopedExerciseResultsPerYearArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
};


export type QueryChartScopedInstitutionsPerConstitutionYearArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  spinoffKind?: InputMaybe<SpinoffKind>;
};


export type QueryChartScopedInstitutionsPerDepartmentArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  spinoffKind?: InputMaybe<SpinoffKind>;
};


export type QueryChartScopedInstitutionsPerRecognitionYearArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  spinoffKind?: InputMaybe<SpinoffKind>;
};


export type QueryChartScopedInstitutionsPerSectorArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  spinoffKind?: InputMaybe<SpinoffKind>;
};


export type QueryChartScopedProductionValuesPerYearArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCompensationArgs = {
  id: Scalars['ID'];
};


export type QueryDeliberationArgs = {
  id: Scalars['ID'];
};


export type QueryDepartmentArgs = {
  id: Scalars['ID'];
};


export type QueryDepartmentSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keyword?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryInstitutionArgs = {
  institutionId: Scalars['ID'];
  versionableOptions?: InputMaybe<VersionableOptionsInput>;
};


export type QueryInstitutionSearchArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  institutionType?: InputMaybe<InstitutionTypeEnum>;
  keyword?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  recognitionDateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  showOnly?: InputMaybe<SearchShowOnly>;
  sortFilter?: InputMaybe<SortFilterInput>;
  spinoffParticipation?: InputMaybe<Scalars['Boolean']>;
  withPartnershipPersonKind?: InputMaybe<PartnershipPersonKind>;
};


export type QueryInstitutionsWithExpiringRemindsArgs = {
  expiringWithinDays: Scalars['Int'];
};


export type QueryLegalBodyArgs = {
  id: Scalars['ID'];
};


export type QueryPartnershipArgs = {
  id: Scalars['ID'];
};


export type QueryPaymentArgs = {
  id: Scalars['ID'];
};


export type QueryPersonArgs = {
  id: Scalars['ID'];
};


export type QueryPersonSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keyword?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryQuoteArgs = {
  id: Scalars['ID'];
};


export type QueryRemindArgs = {
  id: Scalars['ID'];
};


export type QueryRemindsArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  expiringWithinDays?: InputMaybe<Scalars['Int']>;
};


export type QueryRoleArgs = {
  id: Scalars['ID'];
};


export type QuerySectorArgs = {
  id: Scalars['ID'];
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};

export type Quote = {
  __typename?: 'Quote';
  amount: Scalars['Float'];
  coanAccount?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  institution?: Maybe<InstitutionInterface>;
  membershipQuote: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  paymentFrequency: PaymentFrequencyEnum;
  payments?: Maybe<Array<Payment>>;
  ua?: Maybe<Scalars['String']>;
  uniIsReceiver: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type QuoteInput = {
  amount?: InputMaybe<Scalars['Float']>;
  coanAccount?: InputMaybe<Scalars['String']>;
  institutionId: Scalars['ID'];
  membershipQuote?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  paymentFrequency?: InputMaybe<PaymentFrequencyEnum>;
  ua?: InputMaybe<Scalars['String']>;
  uniIsReceiver?: InputMaybe<Scalars['Boolean']>;
};

export type Remind = {
  __typename?: 'Remind';
  archived: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdAutomatically?: Maybe<Scalars['Boolean']>;
  date: Scalars['ISO8601Date'];
  description: Scalars['String'];
  id: Scalars['ID'];
  institution?: Maybe<InstitutionInterface>;
  notificationDate?: Maybe<Scalars['ISO8601Date']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type RemindInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  description?: InputMaybe<Scalars['String']>;
  institutionId: Scalars['ID'];
  notificationDate?: InputMaybe<Scalars['ISO8601Date']>;
};

export type Role = Approvable & {
  __typename?: 'Role';
  approved?: Maybe<Scalars['Boolean']>;
  compensations?: Maybe<Array<Compensation>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  endDate?: Maybe<Scalars['ISO8601Date']>;
  expectedEndDate?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  institution: InstitutionInterface;
  legalBody: LegalBody;
  note?: Maybe<Scalars['String']>;
  person: Person;
  roleDocument?: Maybe<Pdf>;
  roleType: RoleTypeEnum;
  startDate?: Maybe<Scalars['ISO8601Date']>;
  uniNominee?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type RoleInput = {
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  expectedEndDate?: InputMaybe<Scalars['ISO8601Date']>;
  institutionId?: InputMaybe<Scalars['ID']>;
  legalBodyId?: InputMaybe<Scalars['ID']>;
  note?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['ID']>;
  roleDocument?: InputMaybe<Scalars['Upload']>;
  roleType?: InputMaybe<RoleTypeEnum>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  uniNominee?: InputMaybe<Scalars['Boolean']>;
};

export enum RoleTypeEnum {
  Director = 'director',
  Member = 'member',
  OtherType = 'otherType',
  President = 'president',
  ViceDirector = 'viceDirector',
  VicePresident = 'vicePresident'
}

export enum SearchShowOnly {
  All = 'All',
  Institutions = 'Institutions',
  ParticipateSpinoffs = 'ParticipateSpinoffs'
}

export type Sector = {
  __typename?: 'Sector';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  institutions?: Maybe<Array<InstitutionInterface>>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};


export type SectorInstitutionsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
};

export type SectorInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type SignInInput = {
  email?: InputMaybe<AuthProviderEmailSignInInput>;
};

export type SignUpInput = {
  email?: InputMaybe<AuthProviderEmailSignUpInput>;
};

export type SortFilterInput = {
  direction: SortKeyDirection;
  key: SortKey;
};

export enum SortKey {
  Name = 'name',
  Reminds = 'reminds'
}

export enum SortKeyDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type Spinoff = InstitutionInterface & {
  __typename?: 'Spinoff';
  active: Scalars['Boolean'];
  adherentStructuresInfo?: Maybe<Array<AdherenceInformation>>;
  adhesionDate?: Maybe<Scalars['ISO8601Date']>;
  allApproved: Scalars['Boolean'];
  annualAccountingReports?: Maybe<Array<AnnualAccountingReport>>;
  atecoActivities?: Maybe<Array<AtecoActivity>>;
  attachments?: Maybe<Array<Attachment>>;
  constitutionDate?: Maybe<Scalars['ISO8601Date']>;
  contacts?: Maybe<Scalars['String']>;
  corporatePurpose?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  deliberations?: Maybe<Array<Deliberation>>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['ISO8601Date']>;
  expiringReminds?: Maybe<Array<Remind>>;
  expiryDate?: Maybe<Scalars['ISO8601Date']>;
  fiscalCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  idUGov?: Maybe<Scalars['String']>;
  incubation?: Maybe<Scalars['Boolean']>;
  innovativeStartup?: Maybe<Scalars['Boolean']>;
  institutionType?: Maybe<InstitutionTypeEnum>;
  isUniParticipate: Scalars['Boolean'];
  isVisible: Scalars['Boolean'];
  legalBodies?: Maybe<Array<LegalBody>>;
  mef?: Maybe<Scalars['Boolean']>;
  nominalValue?: Maybe<Scalars['Float']>;
  note?: Maybe<Scalars['String']>;
  partnerships?: Maybe<Array<Partnership>>;
  patents?: Maybe<Scalars['String']>;
  payments?: Maybe<Array<Payment>>;
  quote?: Maybe<Scalars['Float']>;
  quotes?: Maybe<Array<Quote>>;
  recognitionDate?: Maybe<Scalars['ISO8601Date']>;
  reminds?: Maybe<Array<Remind>>;
  roles?: Maybe<Array<Role>>;
  sector?: Maybe<Sector>;
  startCupParticipant?: Maybe<Scalars['Boolean']>;
  status?: Maybe<InstitutionStatusEnum>;
  unapproved: Array<ApprovableUnion>;
  uniParticipation?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  vAcronym?: Maybe<VersionedString>;
  vAcronyms?: Maybe<Array<VersionedString>>;
  vAdministrativeHeadquarter?: Maybe<VersionedString>;
  vAdministrativeHeadquarters?: Maybe<Array<VersionedString>>;
  vAnnualAccountingReports?: Maybe<Array<AnnualAccountingReport>>;
  vEmail?: Maybe<VersionedString>;
  vEmails?: Maybe<Array<VersionedString>>;
  vLegalResidence?: Maybe<VersionedString>;
  vLegalResidences?: Maybe<Array<VersionedString>>;
  vName?: Maybe<VersionedString>;
  vNames?: Maybe<Array<VersionedString>>;
  vOperationalHeadquarter?: Maybe<VersionedString>;
  vOperationalHeadquarters?: Maybe<Array<VersionedString>>;
  vPartnerships?: Maybe<Array<Partnership>>;
  vPhoneNumber?: Maybe<VersionedString>;
  vPhoneNumbers?: Maybe<Array<VersionedString>>;
  vRoles?: Maybe<Array<Role>>;
  vUniParticipation?: Maybe<VersionedUniParticipation>;
  vUniParticipations?: Maybe<Array<VersionedUniParticipation>>;
  vWebsite?: Maybe<VersionedString>;
  vWebsites?: Maybe<Array<VersionedString>>;
  vatNumber?: Maybe<Scalars['String']>;
  /**
   * partial_intersections = the new record partially intersects with the old record;
   *     								outer_intersections = the new record is bigger than the old record and entirely encloses it;
   *     								inner_intersections = the new record is smaller than the old record and entirely fits in it.
   */
  versionedRecordIntersections: VersionedRecordIntersections;
};


export type SpinoffExpiringRemindsArgs = {
  expiringWithinDays: Scalars['Int'];
};


export type SpinoffVersionedRecordIntersectionsArgs = {
  newRecord: VersionedRecordIntersectionInput;
};

export type SpinoffCreateInput = {
  constitutionDate: Scalars['ISO8601Date'];
  fiscalCode?: InputMaybe<Scalars['String']>;
  institutionType: InstitutionTypeEnum;
  uniParticipation: UniParticipationEnum;
  vLegalResidence: VersionedStringInput;
  vName: VersionedStringInput;
  vatNumber?: InputMaybe<Scalars['String']>;
};

export enum SpinoffKind {
  InnovativeStartup = 'innovative_startup',
  NotParticipate = 'not_participate',
  Participate = 'participate'
}

export type SpinoffUpdateInput = {
  adhesionDate?: InputMaybe<Scalars['ISO8601Date']>;
  constitutionDate?: InputMaybe<Scalars['ISO8601Date']>;
  contacts?: InputMaybe<Scalars['String']>;
  corporatePurpose?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['ISO8601Date']>;
  expiryDate?: InputMaybe<Scalars['ISO8601Date']>;
  fiscalCode?: InputMaybe<Scalars['String']>;
  idUGov?: InputMaybe<Scalars['String']>;
  incubation?: InputMaybe<Scalars['Boolean']>;
  innovativeStartup?: InputMaybe<Scalars['Boolean']>;
  institutionType?: InputMaybe<InstitutionTypeEnum>;
  mef?: InputMaybe<Scalars['Boolean']>;
  nominalValue?: InputMaybe<Scalars['Float']>;
  note?: InputMaybe<Scalars['String']>;
  patents?: InputMaybe<Scalars['String']>;
  quote?: InputMaybe<Scalars['Float']>;
  recognitionDate?: InputMaybe<Scalars['ISO8601Date']>;
  sectorId?: InputMaybe<Scalars['ID']>;
  startCupParticipant?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<InstitutionStatusEnum>;
  vAcronym?: InputMaybe<VersionedStringInput>;
  vAdministrativeHeadquarter?: InputMaybe<VersionedStringInput>;
  vEmail?: InputMaybe<VersionedStringInput>;
  vLegalResidence?: InputMaybe<VersionedStringInput>;
  vName?: InputMaybe<VersionedStringInput>;
  vOperationalHeadquarter?: InputMaybe<VersionedStringInput>;
  vPhoneNumber?: InputMaybe<VersionedStringInput>;
  vUniParticipation?: InputMaybe<VersionedUniParticipationEnumInput>;
  vWebsite?: InputMaybe<VersionedStringInput>;
  vatNumber?: InputMaybe<Scalars['String']>;
};

export type SteeringBody = LegalBody & {
  __typename?: 'SteeringBody';
  bodyType: LegalBodyTypeEnum;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  expectedEmployeeNumber?: Maybe<Scalars['Int']>;
  expiryDate?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  institutionId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Role>>;
  steeringBodyType: SteeringBodyTypeEnum;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type SteeringBodyInput = {
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  expectedEmployeeNumber?: InputMaybe<Scalars['Int']>;
  expiryDate?: InputMaybe<Scalars['ISO8601Date']>;
  institutionId?: InputMaybe<Scalars['ID']>;
  note?: InputMaybe<Scalars['String']>;
  steeringBodyType?: InputMaybe<SteeringBodyTypeEnum>;
};

export enum SteeringBodyTypeEnum {
  AddressBoard = 'addressBoard',
  Assembly = 'assembly',
  BoardOfDirectors = 'boardOfDirectors',
  OtherSteeringBody = 'otherSteeringBody',
  ScientificTechnicalCommittee = 'scientificTechnicalCommittee'
}

export enum UniParticipationEnum {
  Absent = 'absent',
  ConstitutionShare = 'constitutionShare',
  FailedWithShare = 'failedWithShare',
  LiquidatedWithShare = 'liquidatedWithShare',
  PostConstitutionShare = 'postConstitutionShare',
  ShareOffer = 'shareOffer',
  ShareSold = 'shareSold'
}

export type User = {
  __typename?: 'User';
  confirmedAt?: Maybe<Scalars['ISO8601DateTime']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  role: UserRoleEnum;
};

export type UserChangePasswordInput = {
  currentPassword?: InputMaybe<Scalars['String']>;
  newPassword: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};

export type UserConfirmEmailInput = {
  userId: Scalars['ID'];
};

export type UserResetPasswordInput = {
  newPassword: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  resetPasswordToken: Scalars['String'];
};

export type UserResetPasswordRequestInput = {
  email: Scalars['String'];
};

export enum UserRoleEnum {
  InstitutionAdmin = 'institutionAdmin',
  InstitutionOffice = 'institutionOffice',
  SpinoffAdmin = 'spinoffAdmin',
  SpinoffOffice = 'spinoffOffice',
  Viewer = 'viewer'
}

export type UserSignIn = {
  __typename?: 'UserSignIn';
  /** These headers should be attached to every authenticated request. */
  authHeaders: AuthHeaderData;
  user?: Maybe<User>;
};

export type UserUpdateInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<UserRoleEnum>;
};

export type VersionableOptionsInput = {
  approved?: InputMaybe<Scalars['Boolean']>;
  onDate?: InputMaybe<Scalars['ISO8601Date']>;
};

export type VersionedFloat = Approvable & VersionedRecord & {
  __typename?: 'VersionedFloat';
  approved?: Maybe<Scalars['Boolean']>;
  attributeName?: Maybe<Scalars['String']>;
  attributeType?: Maybe<Scalars['String']>;
  attributeValue?: Maybe<Scalars['Float']>;
  genericValue?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  previousVersionedRecords?: Maybe<Array<VersionedRecord>>;
  validFrom?: Maybe<Scalars['ISO8601Date']>;
  validTo?: Maybe<Scalars['ISO8601Date']>;
};

export type VersionedFloatInput = {
  attributeValue: Scalars['Float'];
  validFrom?: InputMaybe<Scalars['ISO8601Date']>;
  validTo?: InputMaybe<Scalars['ISO8601Date']>;
};

export type VersionedInteger = Approvable & VersionedRecord & {
  __typename?: 'VersionedInteger';
  approved?: Maybe<Scalars['Boolean']>;
  attributeName?: Maybe<Scalars['String']>;
  attributeType?: Maybe<Scalars['String']>;
  attributeValue?: Maybe<Scalars['Int']>;
  genericValue?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  previousVersionedRecords?: Maybe<Array<VersionedRecord>>;
  validFrom?: Maybe<Scalars['ISO8601Date']>;
  validTo?: Maybe<Scalars['ISO8601Date']>;
};

export type VersionedIntegerInput = {
  attributeValue: Scalars['Int'];
  validFrom?: InputMaybe<Scalars['ISO8601Date']>;
  validTo?: InputMaybe<Scalars['ISO8601Date']>;
};

export type VersionedRecord = {
  approved?: Maybe<Scalars['Boolean']>;
  attributeName?: Maybe<Scalars['String']>;
  attributeType?: Maybe<Scalars['String']>;
  genericValue?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  previousVersionedRecords?: Maybe<Array<VersionedRecord>>;
  validFrom?: Maybe<Scalars['ISO8601Date']>;
  validTo?: Maybe<Scalars['ISO8601Date']>;
};

export type VersionedRecordIntersectionInput = {
  attributeName: Scalars['String'];
  recordId?: InputMaybe<Scalars['ID']>;
  validFrom?: InputMaybe<Scalars['ISO8601Date']>;
  validTo?: InputMaybe<Scalars['ISO8601Date']>;
};

export type VersionedRecordIntersections = {
  __typename?: 'VersionedRecordIntersections';
  innerIntersections?: Maybe<Array<VersionedRecord>>;
  outerIntersections?: Maybe<Array<VersionedRecord>>;
  partialIntersections?: Maybe<Array<VersionedRecord>>;
};

export type VersionedString = Approvable & VersionedRecord & {
  __typename?: 'VersionedString';
  approved?: Maybe<Scalars['Boolean']>;
  attributeName?: Maybe<Scalars['String']>;
  attributeType?: Maybe<Scalars['String']>;
  attributeValue?: Maybe<Scalars['String']>;
  genericValue?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  previousVersionedRecords?: Maybe<Array<VersionedRecord>>;
  validFrom?: Maybe<Scalars['ISO8601Date']>;
  validTo?: Maybe<Scalars['ISO8601Date']>;
};

export type VersionedStringInput = {
  attributeValue: Scalars['String'];
  validFrom?: InputMaybe<Scalars['ISO8601Date']>;
  validTo?: InputMaybe<Scalars['ISO8601Date']>;
};

export type VersionedUniParticipation = Approvable & VersionedRecord & {
  __typename?: 'VersionedUniParticipation';
  approved?: Maybe<Scalars['Boolean']>;
  attributeName?: Maybe<Scalars['String']>;
  attributeType?: Maybe<Scalars['String']>;
  attributeValue?: Maybe<UniParticipationEnum>;
  genericValue?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  previousVersionedRecords?: Maybe<Array<VersionedRecord>>;
  validFrom?: Maybe<Scalars['ISO8601Date']>;
  validTo?: Maybe<Scalars['ISO8601Date']>;
};

export type VersionedUniParticipationEnumInput = {
  attributeValue: UniParticipationEnum;
  validFrom?: InputMaybe<Scalars['ISO8601Date']>;
  validTo?: InputMaybe<Scalars['ISO8601Date']>;
};

export type YearValue = {
  __typename?: 'YearValue';
  values: Array<Scalars['Int']>;
  years: Array<Scalars['String']>;
};

export type UserSignOutMutationVariables = Exact<{ [key: string]: never; }>;


export type UserSignOutMutation = { __typename?: 'Mutation', userSignOut?: { __typename?: 'User', id: string } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'User', confirmedAt?: any | null, email?: string | null, id: string, name?: string | null, role: UserRoleEnum } | null };

export type InstitutionsWithExpiringRemindsQueryVariables = Exact<{
  expiringWithinDays: Scalars['Int'];
}>;


export type InstitutionsWithExpiringRemindsQuery = { __typename?: 'Query', institutionsWithExpiringReminds?: Array<{ __typename?: 'Institution', id: string, isVisible: boolean, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null, expiringReminds?: Array<{ __typename?: 'Remind', id: string, notificationDate?: any | null, date: any, archived: boolean }> | null } | { __typename?: 'Spinoff', id: string, isVisible: boolean, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null, expiringReminds?: Array<{ __typename?: 'Remind', id: string, notificationDate?: any | null, date: any, archived: boolean }> | null }> | null };

export type ChartActiveInstitutionsAndSpinoffsPerDepartmentQueryVariables = Exact<{ [key: string]: never; }>;


export type ChartActiveInstitutionsAndSpinoffsPerDepartmentQuery = { __typename?: 'Query', chartActiveInstitutionsAndSpinoffsPerDepartment?: { __typename?: 'DepartmentValue', departmentNames: Array<string>, values: Array<number> } | null };

export type ChartActiveSpinoffsPerDepartmentQueryVariables = Exact<{ [key: string]: never; }>;


export type ChartActiveSpinoffsPerDepartmentQuery = { __typename?: 'Query', chartActiveSpinoffsPerDepartment?: { __typename?: 'DepartmentValue', departmentNames: Array<string>, values: Array<number> } | null };

export type ChartActiveSpinoffsPerYearQueryVariables = Exact<{
  fromYear: Scalars['Int'];
  toYear: Scalars['Int'];
}>;


export type ChartActiveSpinoffsPerYearQuery = { __typename?: 'Query', chartActiveSpinoffsPerYear?: { __typename?: 'YearValue', values: Array<number>, years: Array<string> } | null };

export type AdminInstitutionsWithUnapprovedQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminInstitutionsWithUnapprovedQuery = { __typename?: 'Query', adminInstitutionsWithUnapproved?: Array<{ __typename?: 'Institution', id: string, allApproved: boolean, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null } | { __typename?: 'Spinoff', id: string, allApproved: boolean, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null }> | null };

export type ChartActiveInstitutionsPerDepartmentQueryVariables = Exact<{ [key: string]: never; }>;


export type ChartActiveInstitutionsPerDepartmentQuery = { __typename?: 'Query', chartScopedInstitutionsPerDepartment?: { __typename?: 'NameValue', names: Array<string>, values: Array<number> } | null };

export type DepartmentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DepartmentQuery = { __typename?: 'Query', department?: { __typename?: 'Department', id: string, name: string, adherentInstitutionsInfo?: Array<{ __typename?: 'AdherenceInformation', personRole?: PersonRoleEnum | null, institution: { __typename?: 'Institution', id: string, isVisible: boolean, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | { __typename?: 'Spinoff', id: string, isVisible: boolean, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null }, person?: { __typename?: 'Person', id: string, name: string } | null }> | null } | null };

export type DepartmentSearchQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  keyword: Scalars['String'];
}>;


export type DepartmentSearchQuery = { __typename?: 'Query', departmentSearch?: { __typename?: 'DepartmentConnection', totalCount: number, edges?: Array<{ __typename?: 'DepartmentEdge', node?: { __typename?: 'Department', id: string, name: string, fake: boolean } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type RemindCreateMutationVariables = Exact<{
  input: RemindInput;
}>;


export type RemindCreateMutation = { __typename?: 'Mutation', remindCreate: { __typename?: 'Remind', archived: boolean, createdAutomatically?: boolean | null, date: any, description: string, id: string, notificationDate?: any | null, institution?: { __typename?: 'Institution', id: string, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | { __typename?: 'Spinoff', id: string, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | null } };

export type ExpirationsRemindsAllQueryVariables = Exact<{
  expiringWithinDays?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
}>;


export type ExpirationsRemindsAllQuery = { __typename?: 'Query', reminds?: Array<{ __typename?: 'Remind', archived: boolean, createdAutomatically?: boolean | null, date: any, description: string, id: string, notificationDate?: any | null, institution?: { __typename?: 'Institution', id: string, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | { __typename?: 'Spinoff', id: string, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | null }> | null };

export type AdherentStructureCreateMutationVariables = Exact<{
  input: AdherentStructureInput;
}>;


export type AdherentStructureCreateMutation = { __typename?: 'Mutation', adherentStructureCreate: { __typename?: 'AdherentStructure', id: string } };

export type AdherentStructureUpdateMutationVariables = Exact<{
  adherentStructureId: Scalars['ID'];
  input: AdherentStructureInput;
}>;


export type AdherentStructureUpdateMutation = { __typename?: 'Mutation', adherentStructureUpdate: { __typename?: 'AdherentStructure', id: string } };

export type AdherentStructureDeleteMutationVariables = Exact<{
  adherentStructureId: Scalars['ID'];
}>;


export type AdherentStructureDeleteMutation = { __typename?: 'Mutation', adherentStructureDelete: { __typename?: 'OperationReturn', success?: OperationReturnTypeEnum | null } };

export type AdherentStructureSearchQueryVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type AdherentStructureSearchQuery = { __typename?: 'Query', adherentStructureSearch?: Array<{ __typename: 'Department', id: string, name: string } | { __typename: 'Institution', id: string, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null } | { __typename: 'Spinoff', id: string, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null }> | null };

export type AtecoActivityCreateMutationVariables = Exact<{
  input: AtecoActivityInput;
}>;


export type AtecoActivityCreateMutation = { __typename?: 'Mutation', atecoActivityCreate: { __typename?: 'AtecoActivity', id: string } };

export type AtecoActivityUpdateMutationVariables = Exact<{
  atecoActivityId: Scalars['ID'];
  input: AtecoActivityInput;
}>;


export type AtecoActivityUpdateMutation = { __typename?: 'Mutation', atecoActivityUpdate: { __typename?: 'AtecoActivity', id: string } };

export type AtecoActivityDeleteMutationVariables = Exact<{
  atecoActivityId: Scalars['ID'];
}>;


export type AtecoActivityDeleteMutation = { __typename?: 'Mutation', atecoActivityDelete: { __typename?: 'OperationReturn', success?: OperationReturnTypeEnum | null } };

export type AtecoSectorSearchQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  keyword: Scalars['String'];
}>;


export type AtecoSectorSearchQuery = { __typename?: 'Query', atecoSectorSearch?: { __typename?: 'AtecoSectorConnection', nodes?: Array<{ __typename?: 'AtecoSector', id: string, name: string, atecoCode?: string | null, description: string } | null> | null } | null };

export type InstitutionQueryVariables = Exact<{
  id: Scalars['ID'];
  versionableOptions?: InputMaybe<VersionableOptionsInput>;
}>;


export type InstitutionQuery = { __typename?: 'Query', institution?: { __typename?: 'Institution', mef?: boolean | null, active: boolean, adhesionDate?: any | null, allApproved: boolean, constitutionDate?: any | null, contacts?: string | null, corporatePurpose?: string | null, duration?: any | null, expiryDate?: any | null, fiscalCode?: string | null, id: string, idUGov?: string | null, institutionType?: InstitutionTypeEnum | null, isUniParticipate: boolean, isVisible: boolean, nominalValue?: number | null, note?: string | null, quote?: number | null, recognitionDate?: any | null, status?: InstitutionStatusEnum | null, uniParticipation?: number | null, vatNumber?: string | null, adherentStructuresInfo?: Array<{ __typename?: 'AdherenceInformation', id: string, personRole?: PersonRoleEnum | null, adherable: { __typename: 'Department', id: string, name: string } | { __typename: 'Institution', id: string, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null } | { __typename: 'Spinoff', id: string, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null }, person?: { __typename?: 'Person', id: string, name: string } | null }> | null, atecoActivities?: Array<{ __typename?: 'AtecoActivity', id: string, percentage: number, atecoSector: { __typename?: 'AtecoSector', id: string, name: string, atecoCode?: string | null, description: string } }> | null, attachments?: Array<{ __typename?: 'Attachment', id: string, name?: string | null, description?: string | null, validFrom?: any | null, expiryDate?: any | null, note?: string | null, attachmentType: AttachmentTypeEnum, attachedDocument: { __typename?: 'Pdf', url?: string | null } }> | null, deliberations?: Array<{ __typename?: 'Deliberation', id: string, description?: DeliberationDescriptionEnum | null, deliberationType: DeliberationTypeEnum, date: any, note?: string | null, deliberationDocument: { __typename?: 'Pdf', url?: string | null } }> | null, legalBodies?: Array<{ __typename?: 'AdministrativeBody', administrativeBodyType: AdministrativeBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'AdvisoryBody', advisoryBodyType: AdvisoryBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'ControlBody', controlBodyType: ControlBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'LegalRepresentative', bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'OtherBody', name: string, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'SteeringBody', steeringBodyType: SteeringBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null }> | null, payments?: Array<{ __typename?: 'Payment', id: string, note?: string | null, paymentDate: any, paymentDocument: { __typename?: 'Pdf', url?: string | null }, quote: { __typename?: 'Quote', id: string } }> | null, quotes?: Array<{ __typename?: 'Quote', ua?: string | null, amount: number, coanAccount?: string | null, id: string, membershipQuote: boolean, note?: string | null, paymentFrequency: PaymentFrequencyEnum, uniIsReceiver: boolean }> | null, reminds?: Array<{ __typename?: 'Remind', archived: boolean, createdAutomatically?: boolean | null, date: any, description: string, id: string, notificationDate?: any | null, institution?: { __typename?: 'Institution', id: string, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | { __typename?: 'Spinoff', id: string, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | null }> | null, sector?: { __typename?: 'Sector', id: string, name: string } | null, unapproved: Array<{ __typename: 'AnnualAccountingReport', id: string, year: number, approved?: boolean | null } | { __typename: 'Partnership', startDate?: any | null, endDate?: any | null, id: string, approved?: boolean | null } | { __typename: 'Role', startDate?: any | null, endDate?: any | null, id: string, approved?: boolean | null } | { __typename: 'VersionedFloat', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null } | { __typename: 'VersionedInteger', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null } | { __typename: 'VersionedString', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null }>, vAcronym?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vAdministrativeHeadquarter?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vAnnualAccountingReports?: Array<{ __typename?: 'AnnualAccountingReport', approved?: boolean | null, consolidatedFinancialReport?: boolean | null, consolidatedUniversityFinancialReport?: boolean | null, dateOfApproval?: any | null, exerciseResult?: number | null, employeeNumber?: number | null, id: string, netAssets?: number | null, note?: string | null, productionValue?: number | null, revenue?: number | null, socialCapital?: string | null, universityFinancialReport?: boolean | null, year: number, approvalDocument?: { __typename?: 'Pdf', url?: string | null } | null, controlBodyReportDocument?: { __typename?: 'Pdf', url?: string | null } | null, supplementaryNoteDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null, vEmail?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vLegalResidence?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vName?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vPartnerships?: Array<{ __typename?: 'Partnership', approved?: boolean | null, endDate?: any | null, id: string, nominalValue?: number | null, note?: string | null, partnerName: string, personKind?: PartnershipPersonKind | null, proposer: boolean, quote?: number | null, startDate?: any | null }> | null, vPhoneNumber?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vRoles?: Array<{ __typename?: 'Role', approved?: boolean | null, endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', id: string } | { __typename?: 'AdvisoryBody', id: string } | { __typename?: 'ControlBody', id: string } | { __typename?: 'LegalRepresentative', id: string } | { __typename?: 'OtherBody', id: string } | { __typename?: 'SteeringBody', id: string }, person: { __typename?: 'Person', id: string, name: string, fiscalCode?: string | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null, vUniParticipation?: { __typename?: 'VersionedUniParticipation', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: UniParticipationEnum | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vOperationalHeadquarter?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vWebsite?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null } | { __typename?: 'Spinoff', incubation?: boolean | null, innovativeStartup?: boolean | null, startCupParticipant?: boolean | null, description?: string | null, patents?: string | null, mef?: boolean | null, active: boolean, adhesionDate?: any | null, allApproved: boolean, constitutionDate?: any | null, contacts?: string | null, corporatePurpose?: string | null, duration?: any | null, expiryDate?: any | null, fiscalCode?: string | null, id: string, idUGov?: string | null, institutionType?: InstitutionTypeEnum | null, isUniParticipate: boolean, isVisible: boolean, nominalValue?: number | null, note?: string | null, quote?: number | null, recognitionDate?: any | null, status?: InstitutionStatusEnum | null, uniParticipation?: number | null, vatNumber?: string | null, adherentStructuresInfo?: Array<{ __typename?: 'AdherenceInformation', id: string, personRole?: PersonRoleEnum | null, adherable: { __typename: 'Department', id: string, name: string } | { __typename: 'Institution', id: string, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null } | { __typename: 'Spinoff', id: string, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null }, person?: { __typename?: 'Person', id: string, name: string } | null }> | null, atecoActivities?: Array<{ __typename?: 'AtecoActivity', id: string, percentage: number, atecoSector: { __typename?: 'AtecoSector', id: string, name: string, atecoCode?: string | null, description: string } }> | null, attachments?: Array<{ __typename?: 'Attachment', id: string, name?: string | null, description?: string | null, validFrom?: any | null, expiryDate?: any | null, note?: string | null, attachmentType: AttachmentTypeEnum, attachedDocument: { __typename?: 'Pdf', url?: string | null } }> | null, deliberations?: Array<{ __typename?: 'Deliberation', id: string, description?: DeliberationDescriptionEnum | null, deliberationType: DeliberationTypeEnum, date: any, note?: string | null, deliberationDocument: { __typename?: 'Pdf', url?: string | null } }> | null, legalBodies?: Array<{ __typename?: 'AdministrativeBody', administrativeBodyType: AdministrativeBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'AdvisoryBody', advisoryBodyType: AdvisoryBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'ControlBody', controlBodyType: ControlBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'LegalRepresentative', bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'OtherBody', name: string, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'SteeringBody', steeringBodyType: SteeringBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null }> | null, payments?: Array<{ __typename?: 'Payment', id: string, note?: string | null, paymentDate: any, paymentDocument: { __typename?: 'Pdf', url?: string | null }, quote: { __typename?: 'Quote', id: string } }> | null, quotes?: Array<{ __typename?: 'Quote', ua?: string | null, amount: number, coanAccount?: string | null, id: string, membershipQuote: boolean, note?: string | null, paymentFrequency: PaymentFrequencyEnum, uniIsReceiver: boolean }> | null, reminds?: Array<{ __typename?: 'Remind', archived: boolean, createdAutomatically?: boolean | null, date: any, description: string, id: string, notificationDate?: any | null, institution?: { __typename?: 'Institution', id: string, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | { __typename?: 'Spinoff', id: string, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | null }> | null, sector?: { __typename?: 'Sector', id: string, name: string } | null, unapproved: Array<{ __typename: 'AnnualAccountingReport', id: string, year: number, approved?: boolean | null } | { __typename: 'Partnership', startDate?: any | null, endDate?: any | null, id: string, approved?: boolean | null } | { __typename: 'Role', startDate?: any | null, endDate?: any | null, id: string, approved?: boolean | null } | { __typename: 'VersionedFloat', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null } | { __typename: 'VersionedInteger', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null } | { __typename: 'VersionedString', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null }>, vAcronym?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vAdministrativeHeadquarter?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vAnnualAccountingReports?: Array<{ __typename?: 'AnnualAccountingReport', approved?: boolean | null, consolidatedFinancialReport?: boolean | null, consolidatedUniversityFinancialReport?: boolean | null, dateOfApproval?: any | null, exerciseResult?: number | null, employeeNumber?: number | null, id: string, netAssets?: number | null, note?: string | null, productionValue?: number | null, revenue?: number | null, socialCapital?: string | null, universityFinancialReport?: boolean | null, year: number, approvalDocument?: { __typename?: 'Pdf', url?: string | null } | null, controlBodyReportDocument?: { __typename?: 'Pdf', url?: string | null } | null, supplementaryNoteDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null, vEmail?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vLegalResidence?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vName?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vPartnerships?: Array<{ __typename?: 'Partnership', approved?: boolean | null, endDate?: any | null, id: string, nominalValue?: number | null, note?: string | null, partnerName: string, personKind?: PartnershipPersonKind | null, proposer: boolean, quote?: number | null, startDate?: any | null }> | null, vPhoneNumber?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vRoles?: Array<{ __typename?: 'Role', approved?: boolean | null, endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', id: string } | { __typename?: 'AdvisoryBody', id: string } | { __typename?: 'ControlBody', id: string } | { __typename?: 'LegalRepresentative', id: string } | { __typename?: 'OtherBody', id: string } | { __typename?: 'SteeringBody', id: string }, person: { __typename?: 'Person', id: string, name: string, fiscalCode?: string | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null, vUniParticipation?: { __typename?: 'VersionedUniParticipation', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: UniParticipationEnum | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vOperationalHeadquarter?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vWebsite?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null } | null };

export type AttachmentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AttachmentQuery = { __typename?: 'Query', attachment?: { __typename?: 'Attachment', id: string, name?: string | null, description?: string | null, validFrom?: any | null, expiryDate?: any | null, note?: string | null, attachmentType: AttachmentTypeEnum, attachedDocument: { __typename?: 'Pdf', url?: string | null } } | null };

export type DeliberationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeliberationQuery = { __typename?: 'Query', deliberation?: { __typename?: 'Deliberation', id: string, description?: DeliberationDescriptionEnum | null, deliberationType: DeliberationTypeEnum, date: any, note?: string | null, deliberationDocument: { __typename?: 'Pdf', url?: string | null } } | null };

export type PartnershipQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PartnershipQuery = { __typename?: 'Query', partnership?: { __typename?: 'Partnership', approved?: boolean | null, endDate?: any | null, id: string, nominalValue?: number | null, note?: string | null, partnerName: string, personKind?: PartnershipPersonKind | null, proposer: boolean, quote?: number | null, startDate?: any | null } | null };

export type QuoteQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QuoteQuery = { __typename?: 'Query', quote?: { __typename?: 'Quote', ua?: string | null, amount: number, coanAccount?: string | null, id: string, membershipQuote: boolean, note?: string | null, paymentFrequency: PaymentFrequencyEnum, uniIsReceiver: boolean } | null };

export type CheckApprovablesQueryVariables = Exact<{
  id: Scalars['ID'];
  versionableOptions?: InputMaybe<VersionableOptionsInput>;
}>;


export type CheckApprovablesQuery = { __typename?: 'Query', institution?: { __typename?: 'Institution', allApproved: boolean, unapproved: Array<{ __typename: 'AnnualAccountingReport', id: string, year: number, approved?: boolean | null } | { __typename: 'Partnership', startDate?: any | null, endDate?: any | null, id: string, approved?: boolean | null } | { __typename: 'Role', startDate?: any | null, endDate?: any | null, id: string, approved?: boolean | null } | { __typename: 'VersionedFloat', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null } | { __typename: 'VersionedInteger', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null } | { __typename: 'VersionedString', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null }> } | { __typename?: 'Spinoff', allApproved: boolean, unapproved: Array<{ __typename: 'AnnualAccountingReport', id: string, year: number, approved?: boolean | null } | { __typename: 'Partnership', startDate?: any | null, endDate?: any | null, id: string, approved?: boolean | null } | { __typename: 'Role', startDate?: any | null, endDate?: any | null, id: string, approved?: boolean | null } | { __typename: 'VersionedFloat', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null } | { __typename: 'VersionedInteger', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null } | { __typename: 'VersionedString', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null }> } | null };

export type CheckComplexDataQueryVariables = Exact<{
  id: Scalars['ID'];
  versionableOptions?: InputMaybe<VersionableOptionsInput>;
}>;


export type CheckComplexDataQuery = { __typename?: 'Query', institution?: { __typename?: 'Institution', adherentStructuresInfo?: Array<{ __typename?: 'AdherenceInformation', id: string, personRole?: PersonRoleEnum | null, adherable: { __typename: 'Department', id: string, name: string } | { __typename: 'Institution', id: string, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null } | { __typename: 'Spinoff', id: string, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null }, person?: { __typename?: 'Person', id: string, name: string } | null }> | null, atecoActivities?: Array<{ __typename?: 'AtecoActivity', id: string, percentage: number, atecoSector: { __typename?: 'AtecoSector', id: string, name: string, atecoCode?: string | null, description: string } }> | null } | { __typename?: 'Spinoff', adherentStructuresInfo?: Array<{ __typename?: 'AdherenceInformation', id: string, personRole?: PersonRoleEnum | null, adherable: { __typename: 'Department', id: string, name: string } | { __typename: 'Institution', id: string, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null } | { __typename: 'Spinoff', id: string, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null }, person?: { __typename?: 'Person', id: string, name: string } | null }> | null, atecoActivities?: Array<{ __typename?: 'AtecoActivity', id: string, percentage: number, atecoSector: { __typename?: 'AtecoSector', id: string, name: string, atecoCode?: string | null, description: string } }> | null } | null };

export type AllSectorsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSectorsQuery = { __typename?: 'Query', allSectors?: Array<{ __typename?: 'Sector', description?: string | null, id: string, name: string }> | null };

export type InstitutionSetStatusMutationVariables = Exact<{
  institutionId: Scalars['ID'];
  status: InstitutionStatusEnum;
}>;


export type InstitutionSetStatusMutation = { __typename?: 'Mutation', institutionSetStatus: { __typename?: 'Institution', id: string, active: boolean } | { __typename?: 'Spinoff', id: string, active: boolean } };

export type InstitutionUpdateMutationVariables = Exact<{
  institutionId: Scalars['ID'];
  institutionInput?: InputMaybe<InstitutionUpdateInput>;
  spinoffInput?: InputMaybe<SpinoffUpdateInput>;
}>;


export type InstitutionUpdateMutation = { __typename?: 'Mutation', institutionUpdate: { __typename?: 'Institution', mef?: boolean | null, active: boolean, adhesionDate?: any | null, allApproved: boolean, constitutionDate?: any | null, contacts?: string | null, corporatePurpose?: string | null, duration?: any | null, expiryDate?: any | null, fiscalCode?: string | null, id: string, idUGov?: string | null, institutionType?: InstitutionTypeEnum | null, isUniParticipate: boolean, isVisible: boolean, nominalValue?: number | null, note?: string | null, quote?: number | null, recognitionDate?: any | null, status?: InstitutionStatusEnum | null, uniParticipation?: number | null, vatNumber?: string | null, adherentStructuresInfo?: Array<{ __typename?: 'AdherenceInformation', id: string, personRole?: PersonRoleEnum | null, adherable: { __typename: 'Department', id: string, name: string } | { __typename: 'Institution', id: string, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null } | { __typename: 'Spinoff', id: string, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null }, person?: { __typename?: 'Person', id: string, name: string } | null }> | null, atecoActivities?: Array<{ __typename?: 'AtecoActivity', id: string, percentage: number, atecoSector: { __typename?: 'AtecoSector', id: string, name: string, atecoCode?: string | null, description: string } }> | null, attachments?: Array<{ __typename?: 'Attachment', id: string, name?: string | null, description?: string | null, validFrom?: any | null, expiryDate?: any | null, note?: string | null, attachmentType: AttachmentTypeEnum, attachedDocument: { __typename?: 'Pdf', url?: string | null } }> | null, deliberations?: Array<{ __typename?: 'Deliberation', id: string, description?: DeliberationDescriptionEnum | null, deliberationType: DeliberationTypeEnum, date: any, note?: string | null, deliberationDocument: { __typename?: 'Pdf', url?: string | null } }> | null, legalBodies?: Array<{ __typename?: 'AdministrativeBody', administrativeBodyType: AdministrativeBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'AdvisoryBody', advisoryBodyType: AdvisoryBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'ControlBody', controlBodyType: ControlBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'LegalRepresentative', bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'OtherBody', name: string, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'SteeringBody', steeringBodyType: SteeringBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null }> | null, payments?: Array<{ __typename?: 'Payment', id: string, note?: string | null, paymentDate: any, paymentDocument: { __typename?: 'Pdf', url?: string | null }, quote: { __typename?: 'Quote', id: string } }> | null, quotes?: Array<{ __typename?: 'Quote', ua?: string | null, amount: number, coanAccount?: string | null, id: string, membershipQuote: boolean, note?: string | null, paymentFrequency: PaymentFrequencyEnum, uniIsReceiver: boolean }> | null, reminds?: Array<{ __typename?: 'Remind', archived: boolean, createdAutomatically?: boolean | null, date: any, description: string, id: string, notificationDate?: any | null, institution?: { __typename?: 'Institution', id: string, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | { __typename?: 'Spinoff', id: string, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | null }> | null, sector?: { __typename?: 'Sector', id: string, name: string } | null, unapproved: Array<{ __typename: 'AnnualAccountingReport', id: string, year: number, approved?: boolean | null } | { __typename: 'Partnership', startDate?: any | null, endDate?: any | null, id: string, approved?: boolean | null } | { __typename: 'Role', startDate?: any | null, endDate?: any | null, id: string, approved?: boolean | null } | { __typename: 'VersionedFloat', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null } | { __typename: 'VersionedInteger', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null } | { __typename: 'VersionedString', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null }>, vAcronym?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vAdministrativeHeadquarter?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vAnnualAccountingReports?: Array<{ __typename?: 'AnnualAccountingReport', approved?: boolean | null, consolidatedFinancialReport?: boolean | null, consolidatedUniversityFinancialReport?: boolean | null, dateOfApproval?: any | null, exerciseResult?: number | null, employeeNumber?: number | null, id: string, netAssets?: number | null, note?: string | null, productionValue?: number | null, revenue?: number | null, socialCapital?: string | null, universityFinancialReport?: boolean | null, year: number, approvalDocument?: { __typename?: 'Pdf', url?: string | null } | null, controlBodyReportDocument?: { __typename?: 'Pdf', url?: string | null } | null, supplementaryNoteDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null, vEmail?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vLegalResidence?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vName?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vPartnerships?: Array<{ __typename?: 'Partnership', approved?: boolean | null, endDate?: any | null, id: string, nominalValue?: number | null, note?: string | null, partnerName: string, personKind?: PartnershipPersonKind | null, proposer: boolean, quote?: number | null, startDate?: any | null }> | null, vPhoneNumber?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vRoles?: Array<{ __typename?: 'Role', approved?: boolean | null, endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', id: string } | { __typename?: 'AdvisoryBody', id: string } | { __typename?: 'ControlBody', id: string } | { __typename?: 'LegalRepresentative', id: string } | { __typename?: 'OtherBody', id: string } | { __typename?: 'SteeringBody', id: string }, person: { __typename?: 'Person', id: string, name: string, fiscalCode?: string | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null, vUniParticipation?: { __typename?: 'VersionedUniParticipation', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: UniParticipationEnum | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vOperationalHeadquarter?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vWebsite?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null } | { __typename?: 'Spinoff', incubation?: boolean | null, innovativeStartup?: boolean | null, startCupParticipant?: boolean | null, description?: string | null, patents?: string | null, mef?: boolean | null, active: boolean, adhesionDate?: any | null, allApproved: boolean, constitutionDate?: any | null, contacts?: string | null, corporatePurpose?: string | null, duration?: any | null, expiryDate?: any | null, fiscalCode?: string | null, id: string, idUGov?: string | null, institutionType?: InstitutionTypeEnum | null, isUniParticipate: boolean, isVisible: boolean, nominalValue?: number | null, note?: string | null, quote?: number | null, recognitionDate?: any | null, status?: InstitutionStatusEnum | null, uniParticipation?: number | null, vatNumber?: string | null, adherentStructuresInfo?: Array<{ __typename?: 'AdherenceInformation', id: string, personRole?: PersonRoleEnum | null, adherable: { __typename: 'Department', id: string, name: string } | { __typename: 'Institution', id: string, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null } | { __typename: 'Spinoff', id: string, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null }, person?: { __typename?: 'Person', id: string, name: string } | null }> | null, atecoActivities?: Array<{ __typename?: 'AtecoActivity', id: string, percentage: number, atecoSector: { __typename?: 'AtecoSector', id: string, name: string, atecoCode?: string | null, description: string } }> | null, attachments?: Array<{ __typename?: 'Attachment', id: string, name?: string | null, description?: string | null, validFrom?: any | null, expiryDate?: any | null, note?: string | null, attachmentType: AttachmentTypeEnum, attachedDocument: { __typename?: 'Pdf', url?: string | null } }> | null, deliberations?: Array<{ __typename?: 'Deliberation', id: string, description?: DeliberationDescriptionEnum | null, deliberationType: DeliberationTypeEnum, date: any, note?: string | null, deliberationDocument: { __typename?: 'Pdf', url?: string | null } }> | null, legalBodies?: Array<{ __typename?: 'AdministrativeBody', administrativeBodyType: AdministrativeBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'AdvisoryBody', advisoryBodyType: AdvisoryBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'ControlBody', controlBodyType: ControlBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'LegalRepresentative', bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'OtherBody', name: string, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'SteeringBody', steeringBodyType: SteeringBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null }> | null, payments?: Array<{ __typename?: 'Payment', id: string, note?: string | null, paymentDate: any, paymentDocument: { __typename?: 'Pdf', url?: string | null }, quote: { __typename?: 'Quote', id: string } }> | null, quotes?: Array<{ __typename?: 'Quote', ua?: string | null, amount: number, coanAccount?: string | null, id: string, membershipQuote: boolean, note?: string | null, paymentFrequency: PaymentFrequencyEnum, uniIsReceiver: boolean }> | null, reminds?: Array<{ __typename?: 'Remind', archived: boolean, createdAutomatically?: boolean | null, date: any, description: string, id: string, notificationDate?: any | null, institution?: { __typename?: 'Institution', id: string, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | { __typename?: 'Spinoff', id: string, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | null }> | null, sector?: { __typename?: 'Sector', id: string, name: string } | null, unapproved: Array<{ __typename: 'AnnualAccountingReport', id: string, year: number, approved?: boolean | null } | { __typename: 'Partnership', startDate?: any | null, endDate?: any | null, id: string, approved?: boolean | null } | { __typename: 'Role', startDate?: any | null, endDate?: any | null, id: string, approved?: boolean | null } | { __typename: 'VersionedFloat', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null } | { __typename: 'VersionedInteger', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null } | { __typename: 'VersionedString', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null }>, vAcronym?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vAdministrativeHeadquarter?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vAnnualAccountingReports?: Array<{ __typename?: 'AnnualAccountingReport', approved?: boolean | null, consolidatedFinancialReport?: boolean | null, consolidatedUniversityFinancialReport?: boolean | null, dateOfApproval?: any | null, exerciseResult?: number | null, employeeNumber?: number | null, id: string, netAssets?: number | null, note?: string | null, productionValue?: number | null, revenue?: number | null, socialCapital?: string | null, universityFinancialReport?: boolean | null, year: number, approvalDocument?: { __typename?: 'Pdf', url?: string | null } | null, controlBodyReportDocument?: { __typename?: 'Pdf', url?: string | null } | null, supplementaryNoteDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null, vEmail?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vLegalResidence?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vName?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vPartnerships?: Array<{ __typename?: 'Partnership', approved?: boolean | null, endDate?: any | null, id: string, nominalValue?: number | null, note?: string | null, partnerName: string, personKind?: PartnershipPersonKind | null, proposer: boolean, quote?: number | null, startDate?: any | null }> | null, vPhoneNumber?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vRoles?: Array<{ __typename?: 'Role', approved?: boolean | null, endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', id: string } | { __typename?: 'AdvisoryBody', id: string } | { __typename?: 'ControlBody', id: string } | { __typename?: 'LegalRepresentative', id: string } | { __typename?: 'OtherBody', id: string } | { __typename?: 'SteeringBody', id: string }, person: { __typename?: 'Person', id: string, name: string, fiscalCode?: string | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null, vUniParticipation?: { __typename?: 'VersionedUniParticipation', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: UniParticipationEnum | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vOperationalHeadquarter?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vWebsite?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null } };

export type ApprovableApproveMutationVariables = Exact<{
  input: ApprovableInput;
}>;


export type ApprovableApproveMutation = { __typename?: 'Mutation', approvableApprove: { __typename: 'AnnualAccountingReport', id: string, approved?: boolean | null } | { __typename: 'Partnership', id: string, approved?: boolean | null } | { __typename: 'Role', id: string, approved?: boolean | null } | { __typename: 'VersionedFloat', id: string, attributeName?: string | null, approved?: boolean | null } | { __typename: 'VersionedInteger', id: string, attributeName?: string | null, approved?: boolean | null } | { __typename: 'VersionedString', id: string, attributeName?: string | null, approved?: boolean | null } };

export type ApprovableApproveManyMutationVariables = Exact<{
  input: Array<ApprovableInput> | ApprovableInput;
}>;


export type ApprovableApproveManyMutation = { __typename?: 'Mutation', approvableApproveMany: boolean };

export type AttachmentCreateMutationVariables = Exact<{
  input: AttachmentInput;
}>;


export type AttachmentCreateMutation = { __typename?: 'Mutation', attachmentCreate: { __typename?: 'Attachment', id: string, name?: string | null, description?: string | null, validFrom?: any | null, expiryDate?: any | null, note?: string | null, attachmentType: AttachmentTypeEnum, attachedDocument: { __typename?: 'Pdf', url?: string | null } } };

export type AttachmentUpdateMutationVariables = Exact<{
  attachmentId: Scalars['ID'];
  input: AttachmentInput;
}>;


export type AttachmentUpdateMutation = { __typename?: 'Mutation', attachmentUpdate: { __typename?: 'Attachment', id: string, name?: string | null, description?: string | null, validFrom?: any | null, expiryDate?: any | null, note?: string | null, attachmentType: AttachmentTypeEnum, attachedDocument: { __typename?: 'Pdf', url?: string | null } } };

export type AttachmentDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AttachmentDeleteMutation = { __typename?: 'Mutation', attachmentDelete: { __typename?: 'OperationReturn', success?: OperationReturnTypeEnum | null } };

export type DeliberationCreateMutationVariables = Exact<{
  input: DeliberationInput;
}>;


export type DeliberationCreateMutation = { __typename?: 'Mutation', deliberationCreate: { __typename?: 'Deliberation', id: string, description?: DeliberationDescriptionEnum | null, deliberationType: DeliberationTypeEnum, date: any, note?: string | null, deliberationDocument: { __typename?: 'Pdf', url?: string | null } } };

export type DeliberationUpdateMutationVariables = Exact<{
  deliberationId: Scalars['ID'];
  input: DeliberationInput;
}>;


export type DeliberationUpdateMutation = { __typename?: 'Mutation', deliberationUpdate: { __typename?: 'Deliberation', id: string, description?: DeliberationDescriptionEnum | null, deliberationType: DeliberationTypeEnum, date: any, note?: string | null, deliberationDocument: { __typename?: 'Pdf', url?: string | null } } };

export type DeliberationDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeliberationDeleteMutation = { __typename?: 'Mutation', deliberationDelete: { __typename?: 'OperationReturn', success?: OperationReturnTypeEnum | null } };

export type PartnershipCreateMutationVariables = Exact<{
  input: PartnershipInput;
}>;


export type PartnershipCreateMutation = { __typename?: 'Mutation', partnershipCreate: { __typename?: 'Partnership', approved?: boolean | null, endDate?: any | null, id: string, nominalValue?: number | null, note?: string | null, partnerName: string, personKind?: PartnershipPersonKind | null, proposer: boolean, quote?: number | null, startDate?: any | null } };

export type PartnershipUpdateMutationVariables = Exact<{
  partnershipId: Scalars['ID'];
  input: PartnershipInput;
}>;


export type PartnershipUpdateMutation = { __typename?: 'Mutation', partnershipUpdate: { __typename?: 'Partnership', approved?: boolean | null, endDate?: any | null, id: string, nominalValue?: number | null, note?: string | null, partnerName: string, personKind?: PartnershipPersonKind | null, proposer: boolean, quote?: number | null, startDate?: any | null } };

export type PartnershipDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PartnershipDeleteMutation = { __typename?: 'Mutation', partnershipDelete: { __typename?: 'OperationReturn', success?: OperationReturnTypeEnum | null } };

export type QuoteCreateMutationVariables = Exact<{
  input: QuoteInput;
}>;


export type QuoteCreateMutation = { __typename?: 'Mutation', quoteCreate: { __typename?: 'Quote', ua?: string | null, amount: number, coanAccount?: string | null, id: string, membershipQuote: boolean, note?: string | null, paymentFrequency: PaymentFrequencyEnum, uniIsReceiver: boolean } };

export type QuoteUpdateMutationVariables = Exact<{
  quoteId: Scalars['ID'];
  input: QuoteInput;
}>;


export type QuoteUpdateMutation = { __typename?: 'Mutation', quoteUpdate: { __typename?: 'Quote', ua?: string | null, amount: number, coanAccount?: string | null, id: string, membershipQuote: boolean, note?: string | null, paymentFrequency: PaymentFrequencyEnum, uniIsReceiver: boolean } };

export type QuoteDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QuoteDeleteMutation = { __typename?: 'Mutation', quoteDelete: { __typename?: 'OperationReturn', success?: OperationReturnTypeEnum | null } };

export type AnnualAccountingReportCreateMutationVariables = Exact<{
  input: AnnualAccountingReportInput;
}>;


export type AnnualAccountingReportCreateMutation = { __typename?: 'Mutation', annualAccountingReportCreate: { __typename?: 'AnnualAccountingReport', approved?: boolean | null, consolidatedFinancialReport?: boolean | null, consolidatedUniversityFinancialReport?: boolean | null, dateOfApproval?: any | null, exerciseResult?: number | null, employeeNumber?: number | null, id: string, netAssets?: number | null, note?: string | null, productionValue?: number | null, revenue?: number | null, socialCapital?: string | null, universityFinancialReport?: boolean | null, year: number, approvalDocument?: { __typename?: 'Pdf', url?: string | null } | null, controlBodyReportDocument?: { __typename?: 'Pdf', url?: string | null } | null, supplementaryNoteDocument?: { __typename?: 'Pdf', url?: string | null } | null } };

export type AnnualAccountingReportUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  input: AnnualAccountingReportInput;
}>;


export type AnnualAccountingReportUpdateMutation = { __typename?: 'Mutation', annualAccountingReportUpdate: { __typename?: 'AnnualAccountingReport', approved?: boolean | null, consolidatedFinancialReport?: boolean | null, consolidatedUniversityFinancialReport?: boolean | null, dateOfApproval?: any | null, exerciseResult?: number | null, employeeNumber?: number | null, id: string, netAssets?: number | null, note?: string | null, productionValue?: number | null, revenue?: number | null, socialCapital?: string | null, universityFinancialReport?: boolean | null, year: number, approvalDocument?: { __typename?: 'Pdf', url?: string | null } | null, controlBodyReportDocument?: { __typename?: 'Pdf', url?: string | null } | null, supplementaryNoteDocument?: { __typename?: 'Pdf', url?: string | null } | null } };

export type PaymentCreateMutationVariables = Exact<{
  input: PaymentInput;
}>;


export type PaymentCreateMutation = { __typename?: 'Mutation', paymentCreate: { __typename?: 'Payment', id: string, note?: string | null, paymentDate: any, paymentDocument: { __typename?: 'Pdf', url?: string | null }, quote: { __typename?: 'Quote', id: string } } };

export type PaymentUpdateMutationVariables = Exact<{
  paymentId: Scalars['ID'];
  input: PaymentInput;
}>;


export type PaymentUpdateMutation = { __typename?: 'Mutation', paymentUpdate: { __typename?: 'Payment', id: string, note?: string | null, paymentDate: any, paymentDocument: { __typename?: 'Pdf', url?: string | null }, quote: { __typename?: 'Quote', id: string } } };

export type PaymentDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PaymentDeleteMutation = { __typename?: 'Mutation', paymentDelete: { __typename?: 'OperationReturn', success?: OperationReturnTypeEnum | null } };

export type QuotePaymentsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QuotePaymentsQuery = { __typename?: 'Query', quote?: { __typename?: 'Quote', id: string, payments?: Array<{ __typename?: 'Payment', id: string, note?: string | null, paymentDate: any, paymentDocument: { __typename?: 'Pdf', url?: string | null }, quote: { __typename?: 'Quote', id: string } }> | null } | null };

export type LegalBodyCreateMutationVariables = Exact<{
  otherBodyInput?: InputMaybe<OtherBodyInput>;
  controlBodyInput?: InputMaybe<ControlBodyInput>;
  advisoryBodyInput?: InputMaybe<AdvisoryBodyInput>;
  administrativeBodyInput?: InputMaybe<AdministrativeBodyInput>;
  steeringBodyInput?: InputMaybe<SteeringBodyInput>;
  legalRepresentativeInput?: InputMaybe<LegalRepresentativeInput>;
}>;


export type LegalBodyCreateMutation = { __typename?: 'Mutation', legalBodyCreate: { __typename?: 'AdministrativeBody', administrativeBodyType: AdministrativeBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null, groupedRoles?: Array<{ __typename?: 'Role', approved?: boolean | null, endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', id: string } | { __typename?: 'AdvisoryBody', id: string } | { __typename?: 'ControlBody', id: string } | { __typename?: 'LegalRepresentative', id: string } | { __typename?: 'OtherBody', id: string } | { __typename?: 'SteeringBody', id: string }, person: { __typename?: 'Person', id: string, name: string, fiscalCode?: string | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null } | { __typename?: 'AdvisoryBody', advisoryBodyType: AdvisoryBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null, groupedRoles?: Array<{ __typename?: 'Role', approved?: boolean | null, endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', id: string } | { __typename?: 'AdvisoryBody', id: string } | { __typename?: 'ControlBody', id: string } | { __typename?: 'LegalRepresentative', id: string } | { __typename?: 'OtherBody', id: string } | { __typename?: 'SteeringBody', id: string }, person: { __typename?: 'Person', id: string, name: string, fiscalCode?: string | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null } | { __typename?: 'ControlBody', controlBodyType: ControlBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null, groupedRoles?: Array<{ __typename?: 'Role', approved?: boolean | null, endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', id: string } | { __typename?: 'AdvisoryBody', id: string } | { __typename?: 'ControlBody', id: string } | { __typename?: 'LegalRepresentative', id: string } | { __typename?: 'OtherBody', id: string } | { __typename?: 'SteeringBody', id: string }, person: { __typename?: 'Person', id: string, name: string, fiscalCode?: string | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null } | { __typename?: 'LegalRepresentative', bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null, groupedRoles?: Array<{ __typename?: 'Role', approved?: boolean | null, endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', id: string } | { __typename?: 'AdvisoryBody', id: string } | { __typename?: 'ControlBody', id: string } | { __typename?: 'LegalRepresentative', id: string } | { __typename?: 'OtherBody', id: string } | { __typename?: 'SteeringBody', id: string }, person: { __typename?: 'Person', id: string, name: string, fiscalCode?: string | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null } | { __typename?: 'OtherBody', name: string, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null, groupedRoles?: Array<{ __typename?: 'Role', approved?: boolean | null, endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', id: string } | { __typename?: 'AdvisoryBody', id: string } | { __typename?: 'ControlBody', id: string } | { __typename?: 'LegalRepresentative', id: string } | { __typename?: 'OtherBody', id: string } | { __typename?: 'SteeringBody', id: string }, person: { __typename?: 'Person', id: string, name: string, fiscalCode?: string | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null } | { __typename?: 'SteeringBody', steeringBodyType: SteeringBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null, groupedRoles?: Array<{ __typename?: 'Role', approved?: boolean | null, endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', id: string } | { __typename?: 'AdvisoryBody', id: string } | { __typename?: 'ControlBody', id: string } | { __typename?: 'LegalRepresentative', id: string } | { __typename?: 'OtherBody', id: string } | { __typename?: 'SteeringBody', id: string }, person: { __typename?: 'Person', id: string, name: string, fiscalCode?: string | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null } };

export type LegalBodyUpdateMutationVariables = Exact<{
  legalBodyId: Scalars['ID'];
  otherBodyInput?: InputMaybe<OtherBodyInput>;
  controlBodyInput?: InputMaybe<ControlBodyInput>;
  advisoryBodyInput?: InputMaybe<AdvisoryBodyInput>;
  administrativeBodyInput?: InputMaybe<AdministrativeBodyInput>;
  steeringBodyInput?: InputMaybe<SteeringBodyInput>;
  legalRepresentativeInput?: InputMaybe<LegalRepresentativeInput>;
}>;


export type LegalBodyUpdateMutation = { __typename?: 'Mutation', legalBodyUpdate: { __typename?: 'AdministrativeBody', administrativeBodyType: AdministrativeBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null, groupedRoles?: Array<{ __typename?: 'Role', approved?: boolean | null, endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', id: string } | { __typename?: 'AdvisoryBody', id: string } | { __typename?: 'ControlBody', id: string } | { __typename?: 'LegalRepresentative', id: string } | { __typename?: 'OtherBody', id: string } | { __typename?: 'SteeringBody', id: string }, person: { __typename?: 'Person', id: string, name: string, fiscalCode?: string | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null } | { __typename?: 'AdvisoryBody', advisoryBodyType: AdvisoryBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null, groupedRoles?: Array<{ __typename?: 'Role', approved?: boolean | null, endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', id: string } | { __typename?: 'AdvisoryBody', id: string } | { __typename?: 'ControlBody', id: string } | { __typename?: 'LegalRepresentative', id: string } | { __typename?: 'OtherBody', id: string } | { __typename?: 'SteeringBody', id: string }, person: { __typename?: 'Person', id: string, name: string, fiscalCode?: string | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null } | { __typename?: 'ControlBody', controlBodyType: ControlBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null, groupedRoles?: Array<{ __typename?: 'Role', approved?: boolean | null, endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', id: string } | { __typename?: 'AdvisoryBody', id: string } | { __typename?: 'ControlBody', id: string } | { __typename?: 'LegalRepresentative', id: string } | { __typename?: 'OtherBody', id: string } | { __typename?: 'SteeringBody', id: string }, person: { __typename?: 'Person', id: string, name: string, fiscalCode?: string | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null } | { __typename?: 'LegalRepresentative', bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null, groupedRoles?: Array<{ __typename?: 'Role', approved?: boolean | null, endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', id: string } | { __typename?: 'AdvisoryBody', id: string } | { __typename?: 'ControlBody', id: string } | { __typename?: 'LegalRepresentative', id: string } | { __typename?: 'OtherBody', id: string } | { __typename?: 'SteeringBody', id: string }, person: { __typename?: 'Person', id: string, name: string, fiscalCode?: string | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null } | { __typename?: 'OtherBody', name: string, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null, groupedRoles?: Array<{ __typename?: 'Role', approved?: boolean | null, endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', id: string } | { __typename?: 'AdvisoryBody', id: string } | { __typename?: 'ControlBody', id: string } | { __typename?: 'LegalRepresentative', id: string } | { __typename?: 'OtherBody', id: string } | { __typename?: 'SteeringBody', id: string }, person: { __typename?: 'Person', id: string, name: string, fiscalCode?: string | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null } | { __typename?: 'SteeringBody', steeringBodyType: SteeringBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null, groupedRoles?: Array<{ __typename?: 'Role', approved?: boolean | null, endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', id: string } | { __typename?: 'AdvisoryBody', id: string } | { __typename?: 'ControlBody', id: string } | { __typename?: 'LegalRepresentative', id: string } | { __typename?: 'OtherBody', id: string } | { __typename?: 'SteeringBody', id: string }, person: { __typename?: 'Person', id: string, name: string, fiscalCode?: string | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null } };

export type LegalBodyDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LegalBodyDeleteMutation = { __typename?: 'Mutation', legalBodyDelete: { __typename?: 'OperationReturn', success?: OperationReturnTypeEnum | null } };

export type RoleCreateMutationVariables = Exact<{
  input: RoleInput;
}>;


export type RoleCreateMutation = { __typename?: 'Mutation', roleCreate: { __typename?: 'Role', approved?: boolean | null, endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', id: string } | { __typename?: 'AdvisoryBody', id: string } | { __typename?: 'ControlBody', id: string } | { __typename?: 'LegalRepresentative', id: string } | { __typename?: 'OtherBody', id: string } | { __typename?: 'SteeringBody', id: string }, person: { __typename?: 'Person', id: string, name: string, fiscalCode?: string | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null } };

export type RoleUpdateMutationVariables = Exact<{
  roleId: Scalars['ID'];
  input: RoleInput;
}>;


export type RoleUpdateMutation = { __typename?: 'Mutation', roleUpdate: { __typename?: 'Role', approved?: boolean | null, endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', id: string } | { __typename?: 'AdvisoryBody', id: string } | { __typename?: 'ControlBody', id: string } | { __typename?: 'LegalRepresentative', id: string } | { __typename?: 'OtherBody', id: string } | { __typename?: 'SteeringBody', id: string }, person: { __typename?: 'Person', id: string, name: string, fiscalCode?: string | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null } };

export type RoleDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RoleDeleteMutation = { __typename?: 'Mutation', roleDelete: { __typename?: 'OperationReturn', success?: OperationReturnTypeEnum | null } };

export type CompensationCreateMutationVariables = Exact<{
  input: CompensationInput;
}>;


export type CompensationCreateMutation = { __typename?: 'Mutation', compensationCreate: { __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number } };

export type CompensationUpdateMutationVariables = Exact<{
  compensationId: Scalars['ID'];
  input: CompensationInput;
}>;


export type CompensationUpdateMutation = { __typename?: 'Mutation', compensationUpdate: { __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number } };

export type CompensationDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CompensationDeleteMutation = { __typename?: 'Mutation', compensationDelete: { __typename?: 'OperationReturn', success?: OperationReturnTypeEnum | null } };

export type RoleCompensationsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RoleCompensationsQuery = { __typename?: 'Query', role?: { __typename?: 'Role', id: string, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null } | null };

export type VersionedRecordUpdateMutationVariables = Exact<{
  versionedRecordId: Scalars['ID'];
  versionedStringInput?: InputMaybe<VersionedStringInput>;
  versionedIntegerInput?: InputMaybe<VersionedIntegerInput>;
  versionedFloatInput?: InputMaybe<VersionedFloatInput>;
  versionedUniParticipationEnumInput?: InputMaybe<VersionedUniParticipationEnumInput>;
}>;


export type VersionedRecordUpdateMutation = { __typename?: 'Mutation', versionedRecordUpdate: { __typename?: 'VersionedFloat', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, float?: number | null } | { __typename?: 'VersionedInteger', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, integer?: number | null } | { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, string?: string | null } | { __typename?: 'VersionedUniParticipation', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, uniPartecipation?: UniParticipationEnum | null } };

export type VersionedRecordDeleteMutationVariables = Exact<{
  versionedRecordId: Scalars['ID'];
}>;


export type VersionedRecordDeleteMutation = { __typename?: 'Mutation', versionedRecordDelete: { __typename?: 'OperationReturn', success?: OperationReturnTypeEnum | null } };

export type InstitutionVersionedRecordIntersectionsQueryVariables = Exact<{
  id: Scalars['ID'];
  versionableOptions?: InputMaybe<VersionableOptionsInput>;
  newRecord: VersionedRecordIntersectionInput;
}>;


export type InstitutionVersionedRecordIntersectionsQuery = { __typename?: 'Query', institution?: { __typename?: 'Institution', versionedRecordIntersections: { __typename?: 'VersionedRecordIntersections', innerIntersections?: Array<{ __typename?: 'VersionedFloat', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null } | { __typename?: 'VersionedInteger', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null } | { __typename?: 'VersionedString', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null } | { __typename?: 'VersionedUniParticipation', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null }> | null, outerIntersections?: Array<{ __typename?: 'VersionedFloat', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null } | { __typename?: 'VersionedInteger', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null } | { __typename?: 'VersionedString', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null } | { __typename?: 'VersionedUniParticipation', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null }> | null, partialIntersections?: Array<{ __typename?: 'VersionedFloat', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null } | { __typename?: 'VersionedInteger', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null } | { __typename?: 'VersionedString', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null } | { __typename?: 'VersionedUniParticipation', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null }> | null } } | { __typename?: 'Spinoff', versionedRecordIntersections: { __typename?: 'VersionedRecordIntersections', innerIntersections?: Array<{ __typename?: 'VersionedFloat', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null } | { __typename?: 'VersionedInteger', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null } | { __typename?: 'VersionedString', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null } | { __typename?: 'VersionedUniParticipation', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null }> | null, outerIntersections?: Array<{ __typename?: 'VersionedFloat', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null } | { __typename?: 'VersionedInteger', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null } | { __typename?: 'VersionedString', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null } | { __typename?: 'VersionedUniParticipation', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null }> | null, partialIntersections?: Array<{ __typename?: 'VersionedFloat', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null } | { __typename?: 'VersionedInteger', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null } | { __typename?: 'VersionedString', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null } | { __typename?: 'VersionedUniParticipation', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null }> | null } } | null };

export type CheckNewAddedVersionedRecordsQueryVariables = Exact<{
  id: Scalars['ID'];
  versionableOptions?: InputMaybe<VersionableOptionsInput>;
}>;


export type CheckNewAddedVersionedRecordsQuery = { __typename?: 'Query', institution?: { __typename?: 'Institution', vAcronym?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vAdministrativeHeadquarter?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vEmail?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vLegalResidence?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vName?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vPhoneNumber?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vUniParticipation?: { __typename?: 'VersionedUniParticipation', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: UniParticipationEnum | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vOperationalHeadquarter?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vWebsite?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null } | { __typename?: 'Spinoff', vAcronym?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vAdministrativeHeadquarter?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vEmail?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vLegalResidence?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vName?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vPhoneNumber?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vUniParticipation?: { __typename?: 'VersionedUniParticipation', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: UniParticipationEnum | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vOperationalHeadquarter?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vWebsite?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null } | null };

export type InstitutionCreateMutationVariables = Exact<{
  institutionInput?: InputMaybe<InstitutionCreateInput>;
  spinoffInput?: InputMaybe<SpinoffCreateInput>;
}>;


export type InstitutionCreateMutation = { __typename?: 'Mutation', institutionCreate?: { __typename?: 'Institution', id: string, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | { __typename?: 'Spinoff', id: string, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | null };

export type InstitutionSearchQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  keyword?: InputMaybe<Scalars['String']>;
  departmentId?: InputMaybe<Scalars['ID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  showOnly?: InputMaybe<SearchShowOnly>;
  institutionType?: InputMaybe<InstitutionTypeEnum>;
  recognitionDateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  withPartnershipPersonKind?: InputMaybe<PartnershipPersonKind>;
  spinoffParticipation?: InputMaybe<Scalars['Boolean']>;
  sortFilter?: InputMaybe<SortFilterInput>;
}>;


export type InstitutionSearchQuery = { __typename?: 'Query', institutionSearch?: { __typename?: 'InstitutionSearchResultConnection', totalCount: number, edges?: Array<{ __typename?: 'InstitutionSearchResultEdge', node?: { __typename?: 'InstitutionSearchResult', foundVersionedRecord?: { __typename?: 'VersionedFloat', id: string, attributeName?: string | null, genericValue?: string | null } | { __typename?: 'VersionedInteger', id: string, attributeName?: string | null, genericValue?: string | null } | { __typename?: 'VersionedString', id: string, attributeName?: string | null, genericValue?: string | null } | { __typename?: 'VersionedUniParticipation', id: string, attributeName?: string | null, genericValue?: string | null } | null, institution?: { __typename?: 'Institution', id: string, fiscalCode?: string | null, vatNumber?: string | null, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null, expiringReminds?: Array<{ __typename?: 'Remind', id: string }> | null } | { __typename?: 'Spinoff', incubation?: boolean | null, id: string, fiscalCode?: string | null, vatNumber?: string | null, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null, expiringReminds?: Array<{ __typename?: 'Remind', id: string }> | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type DepartmentsDropdownListQueryVariables = Exact<{ [key: string]: never; }>;


export type DepartmentsDropdownListQuery = { __typename?: 'Query', departments?: Array<{ __typename?: 'Department', id: string, text: string }> | null };

export type PersonQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PersonQuery = { __typename?: 'Query', person?: { __typename?: 'Person', fiscalCode?: string | null, id: string, name: string, uniEmployee: boolean, personalDocument?: { __typename?: 'Pdf', url?: string | null } | null, roles?: Array<{ __typename?: 'Role', endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', administrativeBodyType: AdministrativeBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'AdvisoryBody', advisoryBodyType: AdvisoryBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'ControlBody', controlBodyType: ControlBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'LegalRepresentative', bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'OtherBody', name: string, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'SteeringBody', steeringBodyType: SteeringBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null }, institution: { __typename?: 'Institution', id: string, isVisible: boolean, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | { __typename?: 'Spinoff', id: string, isVisible: boolean, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null } | null };

export type PersonUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  input: PersonInput;
}>;


export type PersonUpdateMutation = { __typename?: 'Mutation', personUpdate: { __typename?: 'Person', fiscalCode?: string | null, id: string, name: string, uniEmployee: boolean, personalDocument?: { __typename?: 'Pdf', url?: string | null } | null, roles?: Array<{ __typename?: 'Role', endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', administrativeBodyType: AdministrativeBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'AdvisoryBody', advisoryBodyType: AdvisoryBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'ControlBody', controlBodyType: ControlBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'LegalRepresentative', bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'OtherBody', name: string, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'SteeringBody', steeringBodyType: SteeringBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null }, institution: { __typename?: 'Institution', id: string, isVisible: boolean, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | { __typename?: 'Spinoff', id: string, isVisible: boolean, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null } };

export type PersonDeleteMutationVariables = Exact<{
  personId: Scalars['ID'];
}>;


export type PersonDeleteMutation = { __typename?: 'Mutation', personDelete: { __typename?: 'OperationReturn', success?: OperationReturnTypeEnum | null } };

export type PersonCreateMutationVariables = Exact<{
  input: PersonInput;
}>;


export type PersonCreateMutation = { __typename?: 'Mutation', personCreate?: { __typename?: 'Person', id: string, name: string } | null };

export type PersonSearchQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  keyword: Scalars['String'];
}>;


export type PersonSearchQuery = { __typename?: 'Query', personSearch?: { __typename?: 'PersonConnection', totalCount: number, edges?: Array<{ __typename?: 'PersonEdge', node?: { __typename?: 'Person', id: string, name: string, fiscalCode?: string | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type RemindUpdateMutationVariables = Exact<{
  remindId: Scalars['ID'];
  input: RemindInput;
}>;


export type RemindUpdateMutation = { __typename?: 'Mutation', remindUpdate: { __typename?: 'Remind', archived: boolean, createdAutomatically?: boolean | null, date: any, description: string, id: string, notificationDate?: any | null, institution?: { __typename?: 'Institution', id: string, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | { __typename?: 'Spinoff', id: string, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | null } };

export type AnnualAccountingReportFragment = { __typename?: 'AnnualAccountingReport', approved?: boolean | null, consolidatedFinancialReport?: boolean | null, consolidatedUniversityFinancialReport?: boolean | null, dateOfApproval?: any | null, exerciseResult?: number | null, employeeNumber?: number | null, id: string, netAssets?: number | null, note?: string | null, productionValue?: number | null, revenue?: number | null, socialCapital?: string | null, universityFinancialReport?: boolean | null, year: number, approvalDocument?: { __typename?: 'Pdf', url?: string | null } | null, controlBodyReportDocument?: { __typename?: 'Pdf', url?: string | null } | null, supplementaryNoteDocument?: { __typename?: 'Pdf', url?: string | null } | null };

type ApprovableUnion_AnnualAccountingReport_Fragment = { __typename: 'AnnualAccountingReport', id: string, year: number, approved?: boolean | null };

type ApprovableUnion_Partnership_Fragment = { __typename: 'Partnership', startDate?: any | null, endDate?: any | null, id: string, approved?: boolean | null };

type ApprovableUnion_Role_Fragment = { __typename: 'Role', startDate?: any | null, endDate?: any | null, id: string, approved?: boolean | null };

type ApprovableUnion_VersionedFloat_Fragment = { __typename: 'VersionedFloat', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null };

type ApprovableUnion_VersionedInteger_Fragment = { __typename: 'VersionedInteger', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null };

type ApprovableUnion_VersionedString_Fragment = { __typename: 'VersionedString', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null };

export type ApprovableUnionFragment = ApprovableUnion_AnnualAccountingReport_Fragment | ApprovableUnion_Partnership_Fragment | ApprovableUnion_Role_Fragment | ApprovableUnion_VersionedFloat_Fragment | ApprovableUnion_VersionedInteger_Fragment | ApprovableUnion_VersionedString_Fragment;

export type AttachmentFragment = { __typename?: 'Attachment', id: string, name?: string | null, description?: string | null, validFrom?: any | null, expiryDate?: any | null, note?: string | null, attachmentType: AttachmentTypeEnum, attachedDocument: { __typename?: 'Pdf', url?: string | null } };

export type DeliberationFragment = { __typename?: 'Deliberation', id: string, description?: DeliberationDescriptionEnum | null, deliberationType: DeliberationTypeEnum, date: any, note?: string | null, deliberationDocument: { __typename?: 'Pdf', url?: string | null } };

export type InstitutionListItemFragment = { __typename?: 'InstitutionSearchResult', foundVersionedRecord?: { __typename?: 'VersionedFloat', id: string, attributeName?: string | null, genericValue?: string | null } | { __typename?: 'VersionedInteger', id: string, attributeName?: string | null, genericValue?: string | null } | { __typename?: 'VersionedString', id: string, attributeName?: string | null, genericValue?: string | null } | { __typename?: 'VersionedUniParticipation', id: string, attributeName?: string | null, genericValue?: string | null } | null, institution?: { __typename?: 'Institution', id: string, fiscalCode?: string | null, vatNumber?: string | null, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null, expiringReminds?: Array<{ __typename?: 'Remind', id: string }> | null } | { __typename?: 'Spinoff', incubation?: boolean | null, id: string, fiscalCode?: string | null, vatNumber?: string | null, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null, expiringReminds?: Array<{ __typename?: 'Remind', id: string }> | null } | null };

export type AdherenceInformationFragment = { __typename?: 'AdherenceInformation', id: string, personRole?: PersonRoleEnum | null, adherable: { __typename: 'Department', id: string, name: string } | { __typename: 'Institution', id: string, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null } | { __typename: 'Spinoff', id: string, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null }, person?: { __typename?: 'Person', id: string, name: string } | null };

export type AtecoActivityFragment = { __typename?: 'AtecoActivity', id: string, percentage: number, atecoSector: { __typename?: 'AtecoSector', id: string, name: string, atecoCode?: string | null, description: string } };

type InstitutionDetails_Institution_Fragment = { __typename?: 'Institution', mef?: boolean | null, active: boolean, adhesionDate?: any | null, allApproved: boolean, constitutionDate?: any | null, contacts?: string | null, corporatePurpose?: string | null, duration?: any | null, expiryDate?: any | null, fiscalCode?: string | null, id: string, idUGov?: string | null, institutionType?: InstitutionTypeEnum | null, isUniParticipate: boolean, isVisible: boolean, nominalValue?: number | null, note?: string | null, quote?: number | null, recognitionDate?: any | null, status?: InstitutionStatusEnum | null, uniParticipation?: number | null, vatNumber?: string | null, adherentStructuresInfo?: Array<{ __typename?: 'AdherenceInformation', id: string, personRole?: PersonRoleEnum | null, adherable: { __typename: 'Department', id: string, name: string } | { __typename: 'Institution', id: string, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null } | { __typename: 'Spinoff', id: string, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null }, person?: { __typename?: 'Person', id: string, name: string } | null }> | null, atecoActivities?: Array<{ __typename?: 'AtecoActivity', id: string, percentage: number, atecoSector: { __typename?: 'AtecoSector', id: string, name: string, atecoCode?: string | null, description: string } }> | null, attachments?: Array<{ __typename?: 'Attachment', id: string, name?: string | null, description?: string | null, validFrom?: any | null, expiryDate?: any | null, note?: string | null, attachmentType: AttachmentTypeEnum, attachedDocument: { __typename?: 'Pdf', url?: string | null } }> | null, deliberations?: Array<{ __typename?: 'Deliberation', id: string, description?: DeliberationDescriptionEnum | null, deliberationType: DeliberationTypeEnum, date: any, note?: string | null, deliberationDocument: { __typename?: 'Pdf', url?: string | null } }> | null, legalBodies?: Array<{ __typename?: 'AdministrativeBody', administrativeBodyType: AdministrativeBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'AdvisoryBody', advisoryBodyType: AdvisoryBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'ControlBody', controlBodyType: ControlBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'LegalRepresentative', bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'OtherBody', name: string, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'SteeringBody', steeringBodyType: SteeringBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null }> | null, payments?: Array<{ __typename?: 'Payment', id: string, note?: string | null, paymentDate: any, paymentDocument: { __typename?: 'Pdf', url?: string | null }, quote: { __typename?: 'Quote', id: string } }> | null, quotes?: Array<{ __typename?: 'Quote', ua?: string | null, amount: number, coanAccount?: string | null, id: string, membershipQuote: boolean, note?: string | null, paymentFrequency: PaymentFrequencyEnum, uniIsReceiver: boolean }> | null, reminds?: Array<{ __typename?: 'Remind', archived: boolean, createdAutomatically?: boolean | null, date: any, description: string, id: string, notificationDate?: any | null, institution?: { __typename?: 'Institution', id: string, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | { __typename?: 'Spinoff', id: string, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | null }> | null, sector?: { __typename?: 'Sector', id: string, name: string } | null, unapproved: Array<{ __typename: 'AnnualAccountingReport', id: string, year: number, approved?: boolean | null } | { __typename: 'Partnership', startDate?: any | null, endDate?: any | null, id: string, approved?: boolean | null } | { __typename: 'Role', startDate?: any | null, endDate?: any | null, id: string, approved?: boolean | null } | { __typename: 'VersionedFloat', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null } | { __typename: 'VersionedInteger', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null } | { __typename: 'VersionedString', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null }>, vAcronym?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vAdministrativeHeadquarter?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vAnnualAccountingReports?: Array<{ __typename?: 'AnnualAccountingReport', approved?: boolean | null, consolidatedFinancialReport?: boolean | null, consolidatedUniversityFinancialReport?: boolean | null, dateOfApproval?: any | null, exerciseResult?: number | null, employeeNumber?: number | null, id: string, netAssets?: number | null, note?: string | null, productionValue?: number | null, revenue?: number | null, socialCapital?: string | null, universityFinancialReport?: boolean | null, year: number, approvalDocument?: { __typename?: 'Pdf', url?: string | null } | null, controlBodyReportDocument?: { __typename?: 'Pdf', url?: string | null } | null, supplementaryNoteDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null, vEmail?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vLegalResidence?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vName?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vPartnerships?: Array<{ __typename?: 'Partnership', approved?: boolean | null, endDate?: any | null, id: string, nominalValue?: number | null, note?: string | null, partnerName: string, personKind?: PartnershipPersonKind | null, proposer: boolean, quote?: number | null, startDate?: any | null }> | null, vPhoneNumber?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vRoles?: Array<{ __typename?: 'Role', approved?: boolean | null, endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', id: string } | { __typename?: 'AdvisoryBody', id: string } | { __typename?: 'ControlBody', id: string } | { __typename?: 'LegalRepresentative', id: string } | { __typename?: 'OtherBody', id: string } | { __typename?: 'SteeringBody', id: string }, person: { __typename?: 'Person', id: string, name: string, fiscalCode?: string | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null, vUniParticipation?: { __typename?: 'VersionedUniParticipation', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: UniParticipationEnum | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vOperationalHeadquarter?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vWebsite?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null };

type InstitutionDetails_Spinoff_Fragment = { __typename?: 'Spinoff', incubation?: boolean | null, innovativeStartup?: boolean | null, startCupParticipant?: boolean | null, description?: string | null, patents?: string | null, mef?: boolean | null, active: boolean, adhesionDate?: any | null, allApproved: boolean, constitutionDate?: any | null, contacts?: string | null, corporatePurpose?: string | null, duration?: any | null, expiryDate?: any | null, fiscalCode?: string | null, id: string, idUGov?: string | null, institutionType?: InstitutionTypeEnum | null, isUniParticipate: boolean, isVisible: boolean, nominalValue?: number | null, note?: string | null, quote?: number | null, recognitionDate?: any | null, status?: InstitutionStatusEnum | null, uniParticipation?: number | null, vatNumber?: string | null, adherentStructuresInfo?: Array<{ __typename?: 'AdherenceInformation', id: string, personRole?: PersonRoleEnum | null, adherable: { __typename: 'Department', id: string, name: string } | { __typename: 'Institution', id: string, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null } | { __typename: 'Spinoff', id: string, vName?: { __typename?: 'VersionedString', attributeValue?: string | null } | null }, person?: { __typename?: 'Person', id: string, name: string } | null }> | null, atecoActivities?: Array<{ __typename?: 'AtecoActivity', id: string, percentage: number, atecoSector: { __typename?: 'AtecoSector', id: string, name: string, atecoCode?: string | null, description: string } }> | null, attachments?: Array<{ __typename?: 'Attachment', id: string, name?: string | null, description?: string | null, validFrom?: any | null, expiryDate?: any | null, note?: string | null, attachmentType: AttachmentTypeEnum, attachedDocument: { __typename?: 'Pdf', url?: string | null } }> | null, deliberations?: Array<{ __typename?: 'Deliberation', id: string, description?: DeliberationDescriptionEnum | null, deliberationType: DeliberationTypeEnum, date: any, note?: string | null, deliberationDocument: { __typename?: 'Pdf', url?: string | null } }> | null, legalBodies?: Array<{ __typename?: 'AdministrativeBody', administrativeBodyType: AdministrativeBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'AdvisoryBody', advisoryBodyType: AdvisoryBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'ControlBody', controlBodyType: ControlBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'LegalRepresentative', bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'OtherBody', name: string, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'SteeringBody', steeringBodyType: SteeringBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null }> | null, payments?: Array<{ __typename?: 'Payment', id: string, note?: string | null, paymentDate: any, paymentDocument: { __typename?: 'Pdf', url?: string | null }, quote: { __typename?: 'Quote', id: string } }> | null, quotes?: Array<{ __typename?: 'Quote', ua?: string | null, amount: number, coanAccount?: string | null, id: string, membershipQuote: boolean, note?: string | null, paymentFrequency: PaymentFrequencyEnum, uniIsReceiver: boolean }> | null, reminds?: Array<{ __typename?: 'Remind', archived: boolean, createdAutomatically?: boolean | null, date: any, description: string, id: string, notificationDate?: any | null, institution?: { __typename?: 'Institution', id: string, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | { __typename?: 'Spinoff', id: string, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | null }> | null, sector?: { __typename?: 'Sector', id: string, name: string } | null, unapproved: Array<{ __typename: 'AnnualAccountingReport', id: string, year: number, approved?: boolean | null } | { __typename: 'Partnership', startDate?: any | null, endDate?: any | null, id: string, approved?: boolean | null } | { __typename: 'Role', startDate?: any | null, endDate?: any | null, id: string, approved?: boolean | null } | { __typename: 'VersionedFloat', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null } | { __typename: 'VersionedInteger', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null } | { __typename: 'VersionedString', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null }>, vAcronym?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vAdministrativeHeadquarter?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vAnnualAccountingReports?: Array<{ __typename?: 'AnnualAccountingReport', approved?: boolean | null, consolidatedFinancialReport?: boolean | null, consolidatedUniversityFinancialReport?: boolean | null, dateOfApproval?: any | null, exerciseResult?: number | null, employeeNumber?: number | null, id: string, netAssets?: number | null, note?: string | null, productionValue?: number | null, revenue?: number | null, socialCapital?: string | null, universityFinancialReport?: boolean | null, year: number, approvalDocument?: { __typename?: 'Pdf', url?: string | null } | null, controlBodyReportDocument?: { __typename?: 'Pdf', url?: string | null } | null, supplementaryNoteDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null, vEmail?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vLegalResidence?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vName?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vPartnerships?: Array<{ __typename?: 'Partnership', approved?: boolean | null, endDate?: any | null, id: string, nominalValue?: number | null, note?: string | null, partnerName: string, personKind?: PartnershipPersonKind | null, proposer: boolean, quote?: number | null, startDate?: any | null }> | null, vPhoneNumber?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vRoles?: Array<{ __typename?: 'Role', approved?: boolean | null, endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', id: string } | { __typename?: 'AdvisoryBody', id: string } | { __typename?: 'ControlBody', id: string } | { __typename?: 'LegalRepresentative', id: string } | { __typename?: 'OtherBody', id: string } | { __typename?: 'SteeringBody', id: string }, person: { __typename?: 'Person', id: string, name: string, fiscalCode?: string | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null, vUniParticipation?: { __typename?: 'VersionedUniParticipation', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: UniParticipationEnum | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vOperationalHeadquarter?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null, vWebsite?: { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null } | null };

export type InstitutionDetailsFragment = InstitutionDetails_Institution_Fragment | InstitutionDetails_Spinoff_Fragment;

type LegalBody_AdministrativeBody_Fragment = { __typename?: 'AdministrativeBody', administrativeBodyType: AdministrativeBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null };

type LegalBody_AdvisoryBody_Fragment = { __typename?: 'AdvisoryBody', advisoryBodyType: AdvisoryBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null };

type LegalBody_ControlBody_Fragment = { __typename?: 'ControlBody', controlBodyType: ControlBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null };

type LegalBody_LegalRepresentative_Fragment = { __typename?: 'LegalRepresentative', bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null };

type LegalBody_OtherBody_Fragment = { __typename?: 'OtherBody', name: string, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null };

type LegalBody_SteeringBody_Fragment = { __typename?: 'SteeringBody', steeringBodyType: SteeringBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null };

export type LegalBodyFragment = LegalBody_AdministrativeBody_Fragment | LegalBody_AdvisoryBody_Fragment | LegalBody_ControlBody_Fragment | LegalBody_LegalRepresentative_Fragment | LegalBody_OtherBody_Fragment | LegalBody_SteeringBody_Fragment;

export type PartnershipFragment = { __typename?: 'Partnership', approved?: boolean | null, endDate?: any | null, id: string, nominalValue?: number | null, note?: string | null, partnerName: string, personKind?: PartnershipPersonKind | null, proposer: boolean, quote?: number | null, startDate?: any | null };

export type PaymentFragment = { __typename?: 'Payment', id: string, note?: string | null, paymentDate: any, paymentDocument: { __typename?: 'Pdf', url?: string | null }, quote: { __typename?: 'Quote', id: string } };

export type QuoteFragment = { __typename?: 'Quote', ua?: string | null, amount: number, coanAccount?: string | null, id: string, membershipQuote: boolean, note?: string | null, paymentFrequency: PaymentFrequencyEnum, uniIsReceiver: boolean };

export type PersonFragment = { __typename?: 'Person', fiscalCode?: string | null, id: string, name: string, uniEmployee: boolean, personalDocument?: { __typename?: 'Pdf', url?: string | null } | null, roles?: Array<{ __typename?: 'Role', endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', administrativeBodyType: AdministrativeBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'AdvisoryBody', advisoryBodyType: AdvisoryBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'ControlBody', controlBodyType: ControlBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'LegalRepresentative', bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'OtherBody', name: string, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'SteeringBody', steeringBodyType: SteeringBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null }, institution: { __typename?: 'Institution', id: string, isVisible: boolean, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | { __typename?: 'Spinoff', id: string, isVisible: boolean, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null }> | null };

export type RemindFragment = { __typename?: 'Remind', archived: boolean, createdAutomatically?: boolean | null, date: any, description: string, id: string, notificationDate?: any | null, institution?: { __typename?: 'Institution', id: string, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | { __typename?: 'Spinoff', id: string, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | null };

export type CompensationFragment = { __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number };

export type ApprovableRoleFragment = { __typename?: 'Role', approved?: boolean | null, endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', id: string } | { __typename?: 'AdvisoryBody', id: string } | { __typename?: 'ControlBody', id: string } | { __typename?: 'LegalRepresentative', id: string } | { __typename?: 'OtherBody', id: string } | { __typename?: 'SteeringBody', id: string }, person: { __typename?: 'Person', id: string, name: string, fiscalCode?: string | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null };

export type PersonRoleFragment = { __typename?: 'Role', endDate?: any | null, expectedEndDate?: any | null, id: string, note?: string | null, roleType: RoleTypeEnum, startDate?: any | null, uniNominee?: boolean | null, compensations?: Array<{ __typename?: 'Compensation', compensation: number, compensationNature: string, id: string, note?: string | null, year: number }> | null, legalBody: { __typename?: 'AdministrativeBody', administrativeBodyType: AdministrativeBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'AdvisoryBody', advisoryBodyType: AdvisoryBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'ControlBody', controlBodyType: ControlBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'LegalRepresentative', bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'OtherBody', name: string, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null } | { __typename?: 'SteeringBody', steeringBodyType: SteeringBodyTypeEnum, bodyType: LegalBodyTypeEnum, description?: string | null, duration?: number | null, expectedEmployeeNumber?: number | null, expiryDate?: any | null, id: string, note?: string | null }, institution: { __typename?: 'Institution', id: string, isVisible: boolean, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null } | { __typename?: 'Spinoff', id: string, isVisible: boolean, vName?: { __typename?: 'VersionedString', genericValue?: string | null } | null }, roleDocument?: { __typename?: 'Pdf', url?: string | null } | null };

export type UserFragment = { __typename?: 'User', confirmedAt?: any | null, email?: string | null, id: string, name?: string | null, role: UserRoleEnum };

type VersionedRecord_VersionedFloat_Fragment = { __typename?: 'VersionedFloat', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null };

type VersionedRecord_VersionedInteger_Fragment = { __typename?: 'VersionedInteger', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null };

type VersionedRecord_VersionedString_Fragment = { __typename?: 'VersionedString', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null };

type VersionedRecord_VersionedUniParticipation_Fragment = { __typename?: 'VersionedUniParticipation', id: string, attributeName?: string | null, approved?: boolean | null, validFrom?: any | null, validTo?: any | null, genericValue?: string | null };

export type VersionedRecordFragment = VersionedRecord_VersionedFloat_Fragment | VersionedRecord_VersionedInteger_Fragment | VersionedRecord_VersionedString_Fragment | VersionedRecord_VersionedUniParticipation_Fragment;

export type VersionedFloatFragment = { __typename?: 'VersionedFloat', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: number | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null };

export type VersionedIntegerFragment = { __typename?: 'VersionedInteger', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: number | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null };

export type VersionedStringFragment = { __typename?: 'VersionedString', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: string | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null };

export type VersionedUniParticipationFragment = { __typename?: 'VersionedUniParticipation', approved?: boolean | null, attributeName?: string | null, attributeType?: string | null, id: string, validFrom?: any | null, validTo?: any | null, attributeValue?: UniParticipationEnum | null, previousVersionedRecords?: Array<{ __typename?: 'VersionedFloat', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedInteger', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedString', genericValue?: string | null, validFrom?: any | null, validTo?: any | null } | { __typename?: 'VersionedUniParticipation', genericValue?: string | null, validFrom?: any | null, validTo?: any | null }> | null };

export type UserSignInMutationVariables = Exact<{
  input: SignInInput;
}>;


export type UserSignInMutation = { __typename?: 'Mutation', userSignIn: { __typename?: 'UserSignIn', authHeaders: { __typename?: 'AuthHeaderData', accessToken?: string | null, client?: string | null, expiry?: string | null, tokenType?: string | null, uid?: string | null }, user?: { __typename?: 'User', confirmedAt?: any | null, email?: string | null, id: string, name?: string | null, role: UserRoleEnum } | null } };

export type ChartScopedInstitutionsPerSectorQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  spinoffKind?: InputMaybe<SpinoffKind>;
}>;


export type ChartScopedInstitutionsPerSectorQuery = { __typename?: 'Query', chartScopedInstitutionsPerSector?: { __typename?: 'NameValue', names: Array<string>, values: Array<number> } | null };

export type ChartScopedInstitutionsPerDepartmentQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  spinoffKind?: InputMaybe<SpinoffKind>;
}>;


export type ChartScopedInstitutionsPerDepartmentQuery = { __typename?: 'Query', chartScopedInstitutionsPerDepartment?: { __typename?: 'NameValue', names: Array<string>, values: Array<number> } | null };

export type ChartScopedInstitutionsPerRecognitionYearQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  spinoffKind?: InputMaybe<SpinoffKind>;
}>;


export type ChartScopedInstitutionsPerRecognitionYearQuery = { __typename?: 'Query', chartScopedInstitutionsPerRecognitionYear?: { __typename?: 'YearValue', values: Array<number>, years: Array<string> } | null };

export type ChartScopedInstitutionsPerConstitutionYearQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  spinoffKind?: InputMaybe<SpinoffKind>;
}>;


export type ChartScopedInstitutionsPerConstitutionYearQuery = { __typename?: 'Query', chartScopedInstitutionsPerConstitutionYear?: { __typename?: 'YearValue', values: Array<number>, years: Array<string> } | null };

export type ChartScopedProductionValuesPerYearQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type ChartScopedProductionValuesPerYearQuery = { __typename?: 'Query', chartScopedProductionValuesPerYear?: { __typename?: 'YearValue', values: Array<number>, years: Array<string> } | null };

export type ChartScopedExerciseResultsPerYearQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type ChartScopedExerciseResultsPerYearQuery = { __typename?: 'Query', chartScopedExerciseResultsPerYear?: { __typename?: 'YearValue', values: Array<number>, years: Array<string> } | null };

export const InstitutionListItemFragmentDoc = gql`
    fragment InstitutionListItem on InstitutionSearchResult {
  foundVersionedRecord {
    id
    attributeName
    genericValue
  }
  institution {
    id
    fiscalCode
    vatNumber
    vName {
      attributeValue
    }
    expiringReminds(expiringWithinDays: 30) {
      id
    }
    ... on Spinoff {
      incubation
    }
  }
}
    `;
export const AdherenceInformationFragmentDoc = gql`
    fragment AdherenceInformation on AdherenceInformation {
  id
  adherable {
    __typename
    ... on InstitutionInterface {
      id
      vName {
        attributeValue
      }
    }
    ... on Department {
      id
      name
    }
  }
  person {
    id
    name
  }
  personRole
}
    `;
export const AtecoActivityFragmentDoc = gql`
    fragment AtecoActivity on AtecoActivity {
  id
  atecoSector {
    id
    name
    atecoCode
    description
  }
  percentage
}
    `;
export const AttachmentFragmentDoc = gql`
    fragment Attachment on Attachment {
  id
  name
  description
  validFrom
  expiryDate
  note
  attachmentType
  attachedDocument {
    url
  }
}
    `;
export const DeliberationFragmentDoc = gql`
    fragment Deliberation on Deliberation {
  id
  description
  deliberationType
  date
  deliberationType
  deliberationDocument {
    url
  }
  note
}
    `;
export const LegalBodyFragmentDoc = gql`
    fragment LegalBody on LegalBody {
  bodyType
  description
  duration
  expectedEmployeeNumber
  expiryDate
  id
  note
  ... on AdministrativeBody {
    administrativeBodyType
  }
  ... on AdvisoryBody {
    advisoryBodyType
  }
  ... on ControlBody {
    controlBodyType
  }
  ... on SteeringBody {
    steeringBodyType
  }
  ... on OtherBody {
    name
  }
}
    `;
export const PaymentFragmentDoc = gql`
    fragment Payment on Payment {
  id
  note
  paymentDate
  paymentDocument {
    url
  }
  quote {
    id
  }
}
    `;
export const QuoteFragmentDoc = gql`
    fragment Quote on Quote {
  ua
  amount
  coanAccount
  id
  membershipQuote
  note
  paymentFrequency
  uniIsReceiver
}
    `;
export const RemindFragmentDoc = gql`
    fragment Remind on Remind {
  archived
  createdAutomatically
  date
  description
  id
  notificationDate
  institution {
    id
    vName {
      genericValue
    }
  }
}
    `;
export const ApprovableUnionFragmentDoc = gql`
    fragment ApprovableUnion on ApprovableUnion {
  __typename
  ... on VersionedRecord {
    id
    attributeName
    approved
    validFrom
    validTo
  }
  ... on AnnualAccountingReport {
    id
    year
    approved
  }
  ... on Role {
    startDate
    endDate
    id
    approved
  }
  ... on Partnership {
    startDate
    endDate
    id
    approved
  }
}
    `;
export const VersionedStringFragmentDoc = gql`
    fragment VersionedString on VersionedString {
  approved
  attributeName
  attributeType
  id
  validFrom
  validTo
  attributeValue
  previousVersionedRecords {
    genericValue
    validFrom
    validTo
  }
}
    `;
export const AnnualAccountingReportFragmentDoc = gql`
    fragment AnnualAccountingReport on AnnualAccountingReport {
  approvalDocument {
    url
  }
  approved
  consolidatedFinancialReport
  consolidatedUniversityFinancialReport
  controlBodyReportDocument {
    url
  }
  dateOfApproval
  exerciseResult
  employeeNumber
  id
  netAssets
  note
  productionValue
  revenue
  socialCapital
  supplementaryNoteDocument {
    url
  }
  universityFinancialReport
  year
}
    `;
export const PartnershipFragmentDoc = gql`
    fragment Partnership on Partnership {
  approved
  endDate
  id
  nominalValue
  note
  partnerName
  personKind
  proposer
  quote
  startDate
}
    `;
export const CompensationFragmentDoc = gql`
    fragment Compensation on Compensation {
  compensation
  compensationNature
  id
  note
  year
}
    `;
export const ApprovableRoleFragmentDoc = gql`
    fragment ApprovableRole on Role {
  approved
  compensations {
    ...Compensation
  }
  endDate
  expectedEndDate
  id
  legalBody {
    id
  }
  person {
    id
    name
    fiscalCode
  }
  note
  roleDocument {
    url
  }
  roleType
  startDate
  uniNominee
}
    ${CompensationFragmentDoc}`;
export const VersionedUniParticipationFragmentDoc = gql`
    fragment VersionedUniParticipation on VersionedUniParticipation {
  approved
  attributeName
  attributeType
  id
  validFrom
  validTo
  attributeValue
  previousVersionedRecords {
    genericValue
    validFrom
    validTo
  }
}
    `;
export const InstitutionDetailsFragmentDoc = gql`
    fragment InstitutionDetails on InstitutionInterface {
  mef
  active
  adhesionDate
  allApproved
  adherentStructuresInfo {
    ...AdherenceInformation
  }
  atecoActivities {
    ...AtecoActivity
  }
  attachments {
    ...Attachment
  }
  constitutionDate
  contacts
  corporatePurpose
  duration
  deliberations {
    ...Deliberation
  }
  expiryDate
  fiscalCode
  id
  idUGov
  institutionType
  isUniParticipate
  isVisible
  legalBodies {
    ...LegalBody
  }
  nominalValue
  note
  payments {
    ...Payment
  }
  quote
  quotes {
    ...Quote
  }
  recognitionDate
  reminds {
    ...Remind
  }
  sector {
    id
    name
  }
  status
  unapproved {
    ...ApprovableUnion
  }
  uniParticipation
  vAcronym {
    ...VersionedString
  }
  vAdministrativeHeadquarter {
    ...VersionedString
  }
  vAnnualAccountingReports {
    ...AnnualAccountingReport
  }
  vEmail {
    ...VersionedString
  }
  vLegalResidence {
    ...VersionedString
  }
  vName {
    ...VersionedString
  }
  vPartnerships {
    ...Partnership
  }
  vPhoneNumber {
    ...VersionedString
  }
  vRoles {
    ...ApprovableRole
  }
  vUniParticipation {
    ...VersionedUniParticipation
  }
  vOperationalHeadquarter {
    ...VersionedString
  }
  vWebsite {
    ...VersionedString
  }
  vatNumber
  ... on Spinoff {
    incubation
    innovativeStartup
    startCupParticipant
    description
    patents
  }
}
    ${AdherenceInformationFragmentDoc}
${AtecoActivityFragmentDoc}
${AttachmentFragmentDoc}
${DeliberationFragmentDoc}
${LegalBodyFragmentDoc}
${PaymentFragmentDoc}
${QuoteFragmentDoc}
${RemindFragmentDoc}
${ApprovableUnionFragmentDoc}
${VersionedStringFragmentDoc}
${AnnualAccountingReportFragmentDoc}
${PartnershipFragmentDoc}
${ApprovableRoleFragmentDoc}
${VersionedUniParticipationFragmentDoc}`;
export const PersonRoleFragmentDoc = gql`
    fragment PersonRole on Role {
  compensations {
    compensation
    compensationNature
    id
    note
    year
  }
  endDate
  expectedEndDate
  id
  legalBody {
    ...LegalBody
  }
  institution {
    id
    isVisible
    vName {
      genericValue
    }
  }
  note
  roleDocument {
    url
  }
  roleType
  startDate
  uniNominee
}
    ${LegalBodyFragmentDoc}`;
export const PersonFragmentDoc = gql`
    fragment Person on Person {
  fiscalCode
  id
  name
  personalDocument {
    url
  }
  roles {
    ...PersonRole
  }
  uniEmployee
}
    ${PersonRoleFragmentDoc}`;
export const UserFragmentDoc = gql`
    fragment User on User {
  confirmedAt
  email
  id
  name
  role
}
    `;
export const VersionedRecordFragmentDoc = gql`
    fragment VersionedRecord on VersionedRecord {
  id
  attributeName
  approved
  validFrom
  validTo
  genericValue
}
    `;
export const VersionedFloatFragmentDoc = gql`
    fragment VersionedFloat on VersionedFloat {
  approved
  attributeName
  attributeType
  id
  validFrom
  validTo
  attributeValue
  previousVersionedRecords {
    genericValue
    validFrom
    validTo
  }
}
    `;
export const VersionedIntegerFragmentDoc = gql`
    fragment VersionedInteger on VersionedInteger {
  approved
  attributeName
  attributeType
  id
  validFrom
  validTo
  attributeValue
  previousVersionedRecords {
    genericValue
    validFrom
    validTo
  }
}
    `;
export const UserSignOutDocument = gql`
    mutation userSignOut {
  userSignOut {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserSignOutGQL extends Apollo.Mutation<UserSignOutMutation, UserSignOutMutationVariables> {
    document = UserSignOutDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeDocument = gql`
    query me {
  me {
    ...User
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MeGQL extends Apollo.Query<MeQuery, MeQueryVariables> {
    document = MeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InstitutionsWithExpiringRemindsDocument = gql`
    query institutionsWithExpiringReminds($expiringWithinDays: Int!) {
  institutionsWithExpiringReminds(expiringWithinDays: $expiringWithinDays) {
    id
    vName {
      attributeValue
    }
    isVisible
    expiringReminds(expiringWithinDays: $expiringWithinDays) {
      id
      notificationDate
      date
      archived
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InstitutionsWithExpiringRemindsGQL extends Apollo.Query<InstitutionsWithExpiringRemindsQuery, InstitutionsWithExpiringRemindsQueryVariables> {
    document = InstitutionsWithExpiringRemindsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChartActiveInstitutionsAndSpinoffsPerDepartmentDocument = gql`
    query chartActiveInstitutionsAndSpinoffsPerDepartment {
  chartActiveInstitutionsAndSpinoffsPerDepartment {
    departmentNames
    values
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChartActiveInstitutionsAndSpinoffsPerDepartmentGQL extends Apollo.Query<ChartActiveInstitutionsAndSpinoffsPerDepartmentQuery, ChartActiveInstitutionsAndSpinoffsPerDepartmentQueryVariables> {
    document = ChartActiveInstitutionsAndSpinoffsPerDepartmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChartActiveSpinoffsPerDepartmentDocument = gql`
    query chartActiveSpinoffsPerDepartment {
  chartActiveSpinoffsPerDepartment {
    departmentNames
    values
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChartActiveSpinoffsPerDepartmentGQL extends Apollo.Query<ChartActiveSpinoffsPerDepartmentQuery, ChartActiveSpinoffsPerDepartmentQueryVariables> {
    document = ChartActiveSpinoffsPerDepartmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChartActiveSpinoffsPerYearDocument = gql`
    query chartActiveSpinoffsPerYear($fromYear: Int!, $toYear: Int!) {
  chartActiveSpinoffsPerYear(fromYear: $fromYear, toYear: $toYear) {
    values
    years
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChartActiveSpinoffsPerYearGQL extends Apollo.Query<ChartActiveSpinoffsPerYearQuery, ChartActiveSpinoffsPerYearQueryVariables> {
    document = ChartActiveSpinoffsPerYearDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AdminInstitutionsWithUnapprovedDocument = gql`
    query adminInstitutionsWithUnapproved {
  adminInstitutionsWithUnapproved {
    id
    allApproved
    vName {
      attributeValue
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AdminInstitutionsWithUnapprovedGQL extends Apollo.Query<AdminInstitutionsWithUnapprovedQuery, AdminInstitutionsWithUnapprovedQueryVariables> {
    document = AdminInstitutionsWithUnapprovedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChartActiveInstitutionsPerDepartmentDocument = gql`
    query chartActiveInstitutionsPerDepartment {
  chartScopedInstitutionsPerDepartment(active: true) {
    names
    values
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChartActiveInstitutionsPerDepartmentGQL extends Apollo.Query<ChartActiveInstitutionsPerDepartmentQuery, ChartActiveInstitutionsPerDepartmentQueryVariables> {
    document = ChartActiveInstitutionsPerDepartmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DepartmentDocument = gql`
    query department($id: ID!) {
  department(id: $id) {
    adherentInstitutionsInfo(active: true) {
      institution {
        id
        vName {
          genericValue
        }
        isVisible
      }
      person {
        id
        name
      }
      personRole
    }
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DepartmentGQL extends Apollo.Query<DepartmentQuery, DepartmentQueryVariables> {
    document = DepartmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DepartmentSearchDocument = gql`
    query departmentSearch($first: Int, $last: Int, $after: String, $before: String, $keyword: String!) {
  departmentSearch(
    first: $first
    last: $last
    after: $after
    before: $before
    keyword: $keyword
  ) {
    edges {
      node {
        id
        name
        fake
      }
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DepartmentSearchGQL extends Apollo.Query<DepartmentSearchQuery, DepartmentSearchQueryVariables> {
    document = DepartmentSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemindCreateDocument = gql`
    mutation remindCreate($input: RemindInput!) {
  remindCreate(input: $input) {
    ...Remind
  }
}
    ${RemindFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemindCreateGQL extends Apollo.Mutation<RemindCreateMutation, RemindCreateMutationVariables> {
    document = RemindCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExpirationsRemindsAllDocument = gql`
    query expirationsRemindsAll($expiringWithinDays: Int, $archived: Boolean) {
  reminds(expiringWithinDays: $expiringWithinDays, archived: $archived) {
    ...Remind
  }
}
    ${RemindFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ExpirationsRemindsAllGQL extends Apollo.Query<ExpirationsRemindsAllQuery, ExpirationsRemindsAllQueryVariables> {
    document = ExpirationsRemindsAllDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AdherentStructureCreateDocument = gql`
    mutation adherentStructureCreate($input: AdherentStructureInput!) {
  adherentStructureCreate(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AdherentStructureCreateGQL extends Apollo.Mutation<AdherentStructureCreateMutation, AdherentStructureCreateMutationVariables> {
    document = AdherentStructureCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AdherentStructureUpdateDocument = gql`
    mutation adherentStructureUpdate($adherentStructureId: ID!, $input: AdherentStructureInput!) {
  adherentStructureUpdate(
    adherentStructureId: $adherentStructureId
    input: $input
  ) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AdherentStructureUpdateGQL extends Apollo.Mutation<AdherentStructureUpdateMutation, AdherentStructureUpdateMutationVariables> {
    document = AdherentStructureUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AdherentStructureDeleteDocument = gql`
    mutation adherentStructureDelete($adherentStructureId: ID!) {
  adherentStructureDelete(adherentStructureId: $adherentStructureId) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AdherentStructureDeleteGQL extends Apollo.Mutation<AdherentStructureDeleteMutation, AdherentStructureDeleteMutationVariables> {
    document = AdherentStructureDeleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AdherentStructureSearchDocument = gql`
    query adherentStructureSearch($keyword: String, $active: Boolean) {
  adherentStructureSearch(keyword: $keyword, active: $active) {
    __typename
    ... on InstitutionInterface {
      id
      vName {
        attributeValue
      }
    }
    ... on Department {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AdherentStructureSearchGQL extends Apollo.Query<AdherentStructureSearchQuery, AdherentStructureSearchQueryVariables> {
    document = AdherentStructureSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AtecoActivityCreateDocument = gql`
    mutation atecoActivityCreate($input: AtecoActivityInput!) {
  atecoActivityCreate(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AtecoActivityCreateGQL extends Apollo.Mutation<AtecoActivityCreateMutation, AtecoActivityCreateMutationVariables> {
    document = AtecoActivityCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AtecoActivityUpdateDocument = gql`
    mutation atecoActivityUpdate($atecoActivityId: ID!, $input: AtecoActivityInput!) {
  atecoActivityUpdate(atecoActivityId: $atecoActivityId, input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AtecoActivityUpdateGQL extends Apollo.Mutation<AtecoActivityUpdateMutation, AtecoActivityUpdateMutationVariables> {
    document = AtecoActivityUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AtecoActivityDeleteDocument = gql`
    mutation atecoActivityDelete($atecoActivityId: ID!) {
  atecoActivityDelete(atecoActivityId: $atecoActivityId) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AtecoActivityDeleteGQL extends Apollo.Mutation<AtecoActivityDeleteMutation, AtecoActivityDeleteMutationVariables> {
    document = AtecoActivityDeleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AtecoSectorSearchDocument = gql`
    query atecoSectorSearch($first: Int, $last: Int, $after: String, $before: String, $keyword: String!) {
  atecoSectorSearch(
    first: $first
    last: $last
    after: $after
    before: $before
    keyword: $keyword
  ) {
    nodes {
      id
      name
      atecoCode
      description
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AtecoSectorSearchGQL extends Apollo.Query<AtecoSectorSearchQuery, AtecoSectorSearchQueryVariables> {
    document = AtecoSectorSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InstitutionDocument = gql`
    query institution($id: ID!, $versionableOptions: VersionableOptionsInput) {
  institution(institutionId: $id, versionableOptions: $versionableOptions) {
    ...InstitutionDetails
  }
}
    ${InstitutionDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InstitutionGQL extends Apollo.Query<InstitutionQuery, InstitutionQueryVariables> {
    document = InstitutionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AttachmentDocument = gql`
    query attachment($id: ID!) {
  attachment(id: $id) {
    ...Attachment
  }
}
    ${AttachmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AttachmentGQL extends Apollo.Query<AttachmentQuery, AttachmentQueryVariables> {
    document = AttachmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeliberationDocument = gql`
    query deliberation($id: ID!) {
  deliberation(id: $id) {
    ...Deliberation
  }
}
    ${DeliberationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeliberationGQL extends Apollo.Query<DeliberationQuery, DeliberationQueryVariables> {
    document = DeliberationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PartnershipDocument = gql`
    query partnership($id: ID!) {
  partnership(id: $id) {
    ...Partnership
  }
}
    ${PartnershipFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PartnershipGQL extends Apollo.Query<PartnershipQuery, PartnershipQueryVariables> {
    document = PartnershipDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuoteDocument = gql`
    query quote($id: ID!) {
  quote(id: $id) {
    ...Quote
  }
}
    ${QuoteFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class QuoteGQL extends Apollo.Query<QuoteQuery, QuoteQueryVariables> {
    document = QuoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckApprovablesDocument = gql`
    query checkApprovables($id: ID!, $versionableOptions: VersionableOptionsInput) {
  institution(institutionId: $id, versionableOptions: $versionableOptions) {
    allApproved
    unapproved {
      ...ApprovableUnion
    }
  }
}
    ${ApprovableUnionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckApprovablesGQL extends Apollo.Query<CheckApprovablesQuery, CheckApprovablesQueryVariables> {
    document = CheckApprovablesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckComplexDataDocument = gql`
    query checkComplexData($id: ID!, $versionableOptions: VersionableOptionsInput) {
  institution(institutionId: $id, versionableOptions: $versionableOptions) {
    adherentStructuresInfo {
      ...AdherenceInformation
    }
    atecoActivities {
      ...AtecoActivity
    }
  }
}
    ${AdherenceInformationFragmentDoc}
${AtecoActivityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckComplexDataGQL extends Apollo.Query<CheckComplexDataQuery, CheckComplexDataQueryVariables> {
    document = CheckComplexDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllSectorsDocument = gql`
    query allSectors {
  allSectors {
    description
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllSectorsGQL extends Apollo.Query<AllSectorsQuery, AllSectorsQueryVariables> {
    document = AllSectorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InstitutionSetStatusDocument = gql`
    mutation institutionSetStatus($institutionId: ID!, $status: InstitutionStatusEnum!) {
  institutionSetStatus(institutionId: $institutionId, status: $status) {
    id
    active
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InstitutionSetStatusGQL extends Apollo.Mutation<InstitutionSetStatusMutation, InstitutionSetStatusMutationVariables> {
    document = InstitutionSetStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InstitutionUpdateDocument = gql`
    mutation institutionUpdate($institutionId: ID!, $institutionInput: InstitutionUpdateInput, $spinoffInput: SpinoffUpdateInput) {
  institutionUpdate(
    institutionId: $institutionId
    institutionInput: $institutionInput
    spinoffInput: $spinoffInput
  ) {
    ...InstitutionDetails
  }
}
    ${InstitutionDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InstitutionUpdateGQL extends Apollo.Mutation<InstitutionUpdateMutation, InstitutionUpdateMutationVariables> {
    document = InstitutionUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ApprovableApproveDocument = gql`
    mutation approvableApprove($input: ApprovableInput!) {
  approvableApprove(input: $input) {
    __typename
    ... on VersionedRecord {
      id
      attributeName
      approved
    }
    ... on AnnualAccountingReport {
      id
      approved
    }
    ... on Role {
      id
      approved
    }
    ... on Partnership {
      id
      approved
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ApprovableApproveGQL extends Apollo.Mutation<ApprovableApproveMutation, ApprovableApproveMutationVariables> {
    document = ApprovableApproveDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ApprovableApproveManyDocument = gql`
    mutation approvableApproveMany($input: [ApprovableInput!]!) {
  approvableApproveMany(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ApprovableApproveManyGQL extends Apollo.Mutation<ApprovableApproveManyMutation, ApprovableApproveManyMutationVariables> {
    document = ApprovableApproveManyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AttachmentCreateDocument = gql`
    mutation attachmentCreate($input: AttachmentInput!) {
  attachmentCreate(input: $input) {
    ...Attachment
  }
}
    ${AttachmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AttachmentCreateGQL extends Apollo.Mutation<AttachmentCreateMutation, AttachmentCreateMutationVariables> {
    document = AttachmentCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AttachmentUpdateDocument = gql`
    mutation attachmentUpdate($attachmentId: ID!, $input: AttachmentInput!) {
  attachmentUpdate(attachmentId: $attachmentId, input: $input) {
    ...Attachment
  }
}
    ${AttachmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AttachmentUpdateGQL extends Apollo.Mutation<AttachmentUpdateMutation, AttachmentUpdateMutationVariables> {
    document = AttachmentUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AttachmentDeleteDocument = gql`
    mutation attachmentDelete($id: ID!) {
  attachmentDelete(attachmentId: $id) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AttachmentDeleteGQL extends Apollo.Mutation<AttachmentDeleteMutation, AttachmentDeleteMutationVariables> {
    document = AttachmentDeleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeliberationCreateDocument = gql`
    mutation deliberationCreate($input: DeliberationInput!) {
  deliberationCreate(input: $input) {
    ...Deliberation
  }
}
    ${DeliberationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeliberationCreateGQL extends Apollo.Mutation<DeliberationCreateMutation, DeliberationCreateMutationVariables> {
    document = DeliberationCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeliberationUpdateDocument = gql`
    mutation deliberationUpdate($deliberationId: ID!, $input: DeliberationInput!) {
  deliberationUpdate(deliberationId: $deliberationId, input: $input) {
    ...Deliberation
  }
}
    ${DeliberationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeliberationUpdateGQL extends Apollo.Mutation<DeliberationUpdateMutation, DeliberationUpdateMutationVariables> {
    document = DeliberationUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeliberationDeleteDocument = gql`
    mutation deliberationDelete($id: ID!) {
  deliberationDelete(deliberationId: $id) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeliberationDeleteGQL extends Apollo.Mutation<DeliberationDeleteMutation, DeliberationDeleteMutationVariables> {
    document = DeliberationDeleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PartnershipCreateDocument = gql`
    mutation partnershipCreate($input: PartnershipInput!) {
  partnershipCreate(input: $input) {
    ...Partnership
  }
}
    ${PartnershipFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PartnershipCreateGQL extends Apollo.Mutation<PartnershipCreateMutation, PartnershipCreateMutationVariables> {
    document = PartnershipCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PartnershipUpdateDocument = gql`
    mutation partnershipUpdate($partnershipId: ID!, $input: PartnershipInput!) {
  partnershipUpdate(partnershipId: $partnershipId, input: $input) {
    ...Partnership
  }
}
    ${PartnershipFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PartnershipUpdateGQL extends Apollo.Mutation<PartnershipUpdateMutation, PartnershipUpdateMutationVariables> {
    document = PartnershipUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PartnershipDeleteDocument = gql`
    mutation partnershipDelete($id: ID!) {
  partnershipDelete(partnershipId: $id) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PartnershipDeleteGQL extends Apollo.Mutation<PartnershipDeleteMutation, PartnershipDeleteMutationVariables> {
    document = PartnershipDeleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuoteCreateDocument = gql`
    mutation quoteCreate($input: QuoteInput!) {
  quoteCreate(input: $input) {
    ...Quote
  }
}
    ${QuoteFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class QuoteCreateGQL extends Apollo.Mutation<QuoteCreateMutation, QuoteCreateMutationVariables> {
    document = QuoteCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuoteUpdateDocument = gql`
    mutation quoteUpdate($quoteId: ID!, $input: QuoteInput!) {
  quoteUpdate(quoteId: $quoteId, input: $input) {
    ...Quote
  }
}
    ${QuoteFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class QuoteUpdateGQL extends Apollo.Mutation<QuoteUpdateMutation, QuoteUpdateMutationVariables> {
    document = QuoteUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuoteDeleteDocument = gql`
    mutation quoteDelete($id: ID!) {
  quoteDelete(quoteId: $id) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QuoteDeleteGQL extends Apollo.Mutation<QuoteDeleteMutation, QuoteDeleteMutationVariables> {
    document = QuoteDeleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AnnualAccountingReportCreateDocument = gql`
    mutation annualAccountingReportCreate($input: AnnualAccountingReportInput!) {
  annualAccountingReportCreate(input: $input) {
    ...AnnualAccountingReport
  }
}
    ${AnnualAccountingReportFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AnnualAccountingReportCreateGQL extends Apollo.Mutation<AnnualAccountingReportCreateMutation, AnnualAccountingReportCreateMutationVariables> {
    document = AnnualAccountingReportCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AnnualAccountingReportUpdateDocument = gql`
    mutation annualAccountingReportUpdate($id: ID!, $input: AnnualAccountingReportInput!) {
  annualAccountingReportUpdate(annualAccountingReportId: $id, input: $input) {
    ...AnnualAccountingReport
  }
}
    ${AnnualAccountingReportFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AnnualAccountingReportUpdateGQL extends Apollo.Mutation<AnnualAccountingReportUpdateMutation, AnnualAccountingReportUpdateMutationVariables> {
    document = AnnualAccountingReportUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaymentCreateDocument = gql`
    mutation paymentCreate($input: PaymentInput!) {
  paymentCreate(input: $input) {
    ...Payment
  }
}
    ${PaymentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PaymentCreateGQL extends Apollo.Mutation<PaymentCreateMutation, PaymentCreateMutationVariables> {
    document = PaymentCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaymentUpdateDocument = gql`
    mutation paymentUpdate($paymentId: ID!, $input: PaymentInput!) {
  paymentUpdate(paymentId: $paymentId, input: $input) {
    ...Payment
  }
}
    ${PaymentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PaymentUpdateGQL extends Apollo.Mutation<PaymentUpdateMutation, PaymentUpdateMutationVariables> {
    document = PaymentUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaymentDeleteDocument = gql`
    mutation paymentDelete($id: ID!) {
  paymentDelete(paymentId: $id) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaymentDeleteGQL extends Apollo.Mutation<PaymentDeleteMutation, PaymentDeleteMutationVariables> {
    document = PaymentDeleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuotePaymentsDocument = gql`
    query quotePayments($id: ID!) {
  quote(id: $id) {
    id
    payments {
      ...Payment
    }
  }
}
    ${PaymentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class QuotePaymentsGQL extends Apollo.Query<QuotePaymentsQuery, QuotePaymentsQueryVariables> {
    document = QuotePaymentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LegalBodyCreateDocument = gql`
    mutation legalBodyCreate($otherBodyInput: OtherBodyInput, $controlBodyInput: ControlBodyInput, $advisoryBodyInput: AdvisoryBodyInput, $administrativeBodyInput: AdministrativeBodyInput, $steeringBodyInput: SteeringBodyInput, $legalRepresentativeInput: LegalRepresentativeInput) {
  legalBodyCreate(
    otherBodyInput: $otherBodyInput
    controlBodyInput: $controlBodyInput
    advisoryBodyInput: $advisoryBodyInput
    administrativeBodyInput: $administrativeBodyInput
    steeringBodyInput: $steeringBodyInput
    legalRepresentativeInput: $legalRepresentativeInput
  ) {
    ...LegalBody
    groupedRoles: roles {
      ...ApprovableRole
    }
  }
}
    ${LegalBodyFragmentDoc}
${ApprovableRoleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LegalBodyCreateGQL extends Apollo.Mutation<LegalBodyCreateMutation, LegalBodyCreateMutationVariables> {
    document = LegalBodyCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LegalBodyUpdateDocument = gql`
    mutation legalBodyUpdate($legalBodyId: ID!, $otherBodyInput: OtherBodyInput, $controlBodyInput: ControlBodyInput, $advisoryBodyInput: AdvisoryBodyInput, $administrativeBodyInput: AdministrativeBodyInput, $steeringBodyInput: SteeringBodyInput, $legalRepresentativeInput: LegalRepresentativeInput) {
  legalBodyUpdate(
    legalBodyId: $legalBodyId
    otherBodyInput: $otherBodyInput
    controlBodyInput: $controlBodyInput
    advisoryBodyInput: $advisoryBodyInput
    administrativeBodyInput: $administrativeBodyInput
    steeringBodyInput: $steeringBodyInput
    legalRepresentativeInput: $legalRepresentativeInput
  ) {
    ...LegalBody
    groupedRoles: roles {
      ...ApprovableRole
    }
  }
}
    ${LegalBodyFragmentDoc}
${ApprovableRoleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LegalBodyUpdateGQL extends Apollo.Mutation<LegalBodyUpdateMutation, LegalBodyUpdateMutationVariables> {
    document = LegalBodyUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LegalBodyDeleteDocument = gql`
    mutation legalBodyDelete($id: ID!) {
  legalBodyDelete(legalBodyId: $id) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LegalBodyDeleteGQL extends Apollo.Mutation<LegalBodyDeleteMutation, LegalBodyDeleteMutationVariables> {
    document = LegalBodyDeleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RoleCreateDocument = gql`
    mutation roleCreate($input: RoleInput!) {
  roleCreate(input: $input) {
    ...ApprovableRole
  }
}
    ${ApprovableRoleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RoleCreateGQL extends Apollo.Mutation<RoleCreateMutation, RoleCreateMutationVariables> {
    document = RoleCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RoleUpdateDocument = gql`
    mutation roleUpdate($roleId: ID!, $input: RoleInput!) {
  roleUpdate(roleId: $roleId, input: $input) {
    ...ApprovableRole
  }
}
    ${ApprovableRoleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RoleUpdateGQL extends Apollo.Mutation<RoleUpdateMutation, RoleUpdateMutationVariables> {
    document = RoleUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RoleDeleteDocument = gql`
    mutation roleDelete($id: ID!) {
  roleDelete(roleId: $id) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RoleDeleteGQL extends Apollo.Mutation<RoleDeleteMutation, RoleDeleteMutationVariables> {
    document = RoleDeleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompensationCreateDocument = gql`
    mutation compensationCreate($input: CompensationInput!) {
  compensationCreate(input: $input) {
    ...Compensation
  }
}
    ${CompensationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CompensationCreateGQL extends Apollo.Mutation<CompensationCreateMutation, CompensationCreateMutationVariables> {
    document = CompensationCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompensationUpdateDocument = gql`
    mutation compensationUpdate($compensationId: ID!, $input: CompensationInput!) {
  compensationUpdate(compensationId: $compensationId, input: $input) {
    ...Compensation
  }
}
    ${CompensationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CompensationUpdateGQL extends Apollo.Mutation<CompensationUpdateMutation, CompensationUpdateMutationVariables> {
    document = CompensationUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompensationDeleteDocument = gql`
    mutation compensationDelete($id: ID!) {
  compensationDelete(compensationId: $id) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompensationDeleteGQL extends Apollo.Mutation<CompensationDeleteMutation, CompensationDeleteMutationVariables> {
    document = CompensationDeleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RoleCompensationsDocument = gql`
    query roleCompensations($id: ID!) {
  role(id: $id) {
    id
    compensations {
      ...Compensation
    }
  }
}
    ${CompensationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RoleCompensationsGQL extends Apollo.Query<RoleCompensationsQuery, RoleCompensationsQueryVariables> {
    document = RoleCompensationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const VersionedRecordUpdateDocument = gql`
    mutation versionedRecordUpdate($versionedRecordId: ID!, $versionedStringInput: VersionedStringInput, $versionedIntegerInput: VersionedIntegerInput, $versionedFloatInput: VersionedFloatInput, $versionedUniParticipationEnumInput: VersionedUniParticipationEnumInput) {
  versionedRecordUpdate(
    versionedRecordId: $versionedRecordId
    versionedStringInput: $versionedStringInput
    versionedIntegerInput: $versionedIntegerInput
    versionedFloatInput: $versionedFloatInput
    versionedUniParticipationEnumInput: $versionedUniParticipationEnumInput
  ) {
    approved
    attributeName
    attributeType
    id
    validFrom
    validTo
    ... on VersionedString {
      string: attributeValue
    }
    ... on VersionedInteger {
      integer: attributeValue
    }
    ... on VersionedFloat {
      float: attributeValue
    }
    ... on VersionedUniParticipation {
      uniPartecipation: attributeValue
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class VersionedRecordUpdateGQL extends Apollo.Mutation<VersionedRecordUpdateMutation, VersionedRecordUpdateMutationVariables> {
    document = VersionedRecordUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const VersionedRecordDeleteDocument = gql`
    mutation versionedRecordDelete($versionedRecordId: ID!) {
  versionedRecordDelete(versionedRecordId: $versionedRecordId) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class VersionedRecordDeleteGQL extends Apollo.Mutation<VersionedRecordDeleteMutation, VersionedRecordDeleteMutationVariables> {
    document = VersionedRecordDeleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InstitutionVersionedRecordIntersectionsDocument = gql`
    query institutionVersionedRecordIntersections($id: ID!, $versionableOptions: VersionableOptionsInput, $newRecord: VersionedRecordIntersectionInput!) {
  institution(institutionId: $id, versionableOptions: $versionableOptions) {
    versionedRecordIntersections(newRecord: $newRecord) {
      innerIntersections {
        ...VersionedRecord
      }
      outerIntersections {
        ...VersionedRecord
      }
      partialIntersections {
        ...VersionedRecord
      }
    }
  }
}
    ${VersionedRecordFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InstitutionVersionedRecordIntersectionsGQL extends Apollo.Query<InstitutionVersionedRecordIntersectionsQuery, InstitutionVersionedRecordIntersectionsQueryVariables> {
    document = InstitutionVersionedRecordIntersectionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckNewAddedVersionedRecordsDocument = gql`
    query checkNewAddedVersionedRecords($id: ID!, $versionableOptions: VersionableOptionsInput) {
  institution(institutionId: $id, versionableOptions: $versionableOptions) {
    vAcronym {
      ...VersionedString
    }
    vAdministrativeHeadquarter {
      ...VersionedString
    }
    vEmail {
      ...VersionedString
    }
    vLegalResidence {
      ...VersionedString
    }
    vName {
      ...VersionedString
    }
    vPhoneNumber {
      ...VersionedString
    }
    vUniParticipation {
      ...VersionedUniParticipation
    }
    vOperationalHeadquarter {
      ...VersionedString
    }
    vWebsite {
      ...VersionedString
    }
  }
}
    ${VersionedStringFragmentDoc}
${VersionedUniParticipationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckNewAddedVersionedRecordsGQL extends Apollo.Query<CheckNewAddedVersionedRecordsQuery, CheckNewAddedVersionedRecordsQueryVariables> {
    document = CheckNewAddedVersionedRecordsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InstitutionCreateDocument = gql`
    mutation institutionCreate($institutionInput: InstitutionCreateInput, $spinoffInput: SpinoffCreateInput) {
  institutionCreate(
    institutionInput: $institutionInput
    spinoffInput: $spinoffInput
  ) {
    id
    vName {
      genericValue
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InstitutionCreateGQL extends Apollo.Mutation<InstitutionCreateMutation, InstitutionCreateMutationVariables> {
    document = InstitutionCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InstitutionSearchDocument = gql`
    query institutionSearch($first: Int, $last: Int, $after: String, $before: String, $keyword: String, $departmentId: ID, $active: Boolean, $showOnly: SearchShowOnly, $institutionType: InstitutionTypeEnum, $recognitionDateFrom: ISO8601Date, $withPartnershipPersonKind: PartnershipPersonKind, $spinoffParticipation: Boolean, $sortFilter: SortFilterInput) {
  institutionSearch(
    first: $first
    last: $last
    after: $after
    before: $before
    keyword: $keyword
    departmentId: $departmentId
    active: $active
    showOnly: $showOnly
    institutionType: $institutionType
    recognitionDateFrom: $recognitionDateFrom
    withPartnershipPersonKind: $withPartnershipPersonKind
    spinoffParticipation: $spinoffParticipation
    sortFilter: $sortFilter
  ) {
    edges {
      node {
        ...InstitutionListItem
      }
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${InstitutionListItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InstitutionSearchGQL extends Apollo.Query<InstitutionSearchQuery, InstitutionSearchQueryVariables> {
    document = InstitutionSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DepartmentsDropdownListDocument = gql`
    query departmentsDropdownList {
  departments {
    id
    text: name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DepartmentsDropdownListGQL extends Apollo.Query<DepartmentsDropdownListQuery, DepartmentsDropdownListQueryVariables> {
    document = DepartmentsDropdownListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PersonDocument = gql`
    query person($id: ID!) {
  person(id: $id) {
    ...Person
  }
}
    ${PersonFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PersonGQL extends Apollo.Query<PersonQuery, PersonQueryVariables> {
    document = PersonDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PersonUpdateDocument = gql`
    mutation personUpdate($id: ID!, $input: PersonInput!) {
  personUpdate(personId: $id, input: $input) {
    ...Person
  }
}
    ${PersonFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PersonUpdateGQL extends Apollo.Mutation<PersonUpdateMutation, PersonUpdateMutationVariables> {
    document = PersonUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PersonDeleteDocument = gql`
    mutation personDelete($personId: ID!) {
  personDelete(personId: $personId) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PersonDeleteGQL extends Apollo.Mutation<PersonDeleteMutation, PersonDeleteMutationVariables> {
    document = PersonDeleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PersonCreateDocument = gql`
    mutation personCreate($input: PersonInput!) {
  personCreate(input: $input) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PersonCreateGQL extends Apollo.Mutation<PersonCreateMutation, PersonCreateMutationVariables> {
    document = PersonCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PersonSearchDocument = gql`
    query personSearch($first: Int, $last: Int, $after: String, $before: String, $keyword: String!) {
  personSearch(
    first: $first
    last: $last
    after: $after
    before: $before
    keyword: $keyword
  ) {
    edges {
      node {
        id
        name
        fiscalCode
      }
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PersonSearchGQL extends Apollo.Query<PersonSearchQuery, PersonSearchQueryVariables> {
    document = PersonSearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemindUpdateDocument = gql`
    mutation remindUpdate($remindId: ID!, $input: RemindInput!) {
  remindUpdate(remindId: $remindId, input: $input) {
    ...Remind
  }
}
    ${RemindFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemindUpdateGQL extends Apollo.Mutation<RemindUpdateMutation, RemindUpdateMutationVariables> {
    document = RemindUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserSignInDocument = gql`
    mutation userSignIn($input: SignInInput!) {
  userSignIn(input: $input) {
    authHeaders {
      accessToken
      client
      expiry
      tokenType
      uid
    }
    user {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserSignInGQL extends Apollo.Mutation<UserSignInMutation, UserSignInMutationVariables> {
    document = UserSignInDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChartScopedInstitutionsPerSectorDocument = gql`
    query chartScopedInstitutionsPerSector($active: Boolean, $spinoffKind: SpinoffKind) {
  chartScopedInstitutionsPerSector(active: $active, spinoffKind: $spinoffKind) {
    names
    values
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChartScopedInstitutionsPerSectorGQL extends Apollo.Query<ChartScopedInstitutionsPerSectorQuery, ChartScopedInstitutionsPerSectorQueryVariables> {
    document = ChartScopedInstitutionsPerSectorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChartScopedInstitutionsPerDepartmentDocument = gql`
    query chartScopedInstitutionsPerDepartment($active: Boolean, $spinoffKind: SpinoffKind) {
  chartScopedInstitutionsPerDepartment(active: $active, spinoffKind: $spinoffKind) {
    names
    values
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChartScopedInstitutionsPerDepartmentGQL extends Apollo.Query<ChartScopedInstitutionsPerDepartmentQuery, ChartScopedInstitutionsPerDepartmentQueryVariables> {
    document = ChartScopedInstitutionsPerDepartmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChartScopedInstitutionsPerRecognitionYearDocument = gql`
    query chartScopedInstitutionsPerRecognitionYear($active: Boolean, $spinoffKind: SpinoffKind) {
  chartScopedInstitutionsPerRecognitionYear(
    active: $active
    spinoffKind: $spinoffKind
  ) {
    values
    years
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChartScopedInstitutionsPerRecognitionYearGQL extends Apollo.Query<ChartScopedInstitutionsPerRecognitionYearQuery, ChartScopedInstitutionsPerRecognitionYearQueryVariables> {
    document = ChartScopedInstitutionsPerRecognitionYearDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChartScopedInstitutionsPerConstitutionYearDocument = gql`
    query chartScopedInstitutionsPerConstitutionYear($active: Boolean, $spinoffKind: SpinoffKind) {
  chartScopedInstitutionsPerConstitutionYear(
    active: $active
    spinoffKind: $spinoffKind
  ) {
    values
    years
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChartScopedInstitutionsPerConstitutionYearGQL extends Apollo.Query<ChartScopedInstitutionsPerConstitutionYearQuery, ChartScopedInstitutionsPerConstitutionYearQueryVariables> {
    document = ChartScopedInstitutionsPerConstitutionYearDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChartScopedProductionValuesPerYearDocument = gql`
    query chartScopedProductionValuesPerYear($active: Boolean) {
  chartScopedProductionValuesPerYear(active: $active) {
    values
    years
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChartScopedProductionValuesPerYearGQL extends Apollo.Query<ChartScopedProductionValuesPerYearQuery, ChartScopedProductionValuesPerYearQueryVariables> {
    document = ChartScopedProductionValuesPerYearDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChartScopedExerciseResultsPerYearDocument = gql`
    query chartScopedExerciseResultsPerYear($active: Boolean) {
  chartScopedExerciseResultsPerYear(active: $active) {
    values
    years
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChartScopedExerciseResultsPerYearGQL extends Apollo.Query<ChartScopedExerciseResultsPerYearQuery, ChartScopedExerciseResultsPerYearQueryVariables> {
    document = ChartScopedExerciseResultsPerYearDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AdherableUnion": [
      "Department",
      "Institution",
      "Spinoff"
    ],
    "Approvable": [
      "AnnualAccountingReport",
      "Partnership",
      "Role",
      "VersionedFloat",
      "VersionedInteger",
      "VersionedString",
      "VersionedUniParticipation"
    ],
    "ApprovableUnion": [
      "AnnualAccountingReport",
      "Partnership",
      "Role",
      "VersionedFloat",
      "VersionedInteger",
      "VersionedString"
    ],
    "InstitutionInterface": [
      "Institution",
      "Spinoff"
    ],
    "LegalBody": [
      "AdministrativeBody",
      "AdvisoryBody",
      "ControlBody",
      "LegalRepresentative",
      "OtherBody",
      "SteeringBody"
    ],
    "VersionedRecord": [
      "VersionedFloat",
      "VersionedInteger",
      "VersionedString",
      "VersionedUniParticipation"
    ]
  }
};
      export default result;
    